import Et, { useCallback as b, createContext as _t, useContext as vt, useReducer as Tt, useRef as re, useState as G, useEffect as Q, useMemo as ae, forwardRef as St } from "react";
import Pt from "camelize-ts";
import lt from "snakecase-keys";
var $e, Fe = { exports: {} }, le = {}, xe, Xe, ze = {};
function ft() {
  return xe || (xe = 1, e = ze, process.env.NODE_ENV !== "production" && (function() {
    var t = Et, s = 60103, n = 60106;
    e.Fragment = 60107;
    var c = 60108, P = 60114, T = 60109, y = 60110, C = 60112, U = 60113, p = 60120, d = 60115, S = 60116, A = 60121, a = 60122, _ = 60117, v = 60129, l = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var m = Symbol.for;
      s = m("react.element"), n = m("react.portal"), e.Fragment = m("react.fragment"), c = m("react.strict_mode"), P = m("react.profiler"), T = m("react.provider"), y = m("react.context"), C = m("react.forward_ref"), U = m("react.suspense"), p = m("react.suspense_list"), d = m("react.memo"), S = m("react.lazy"), A = m("react.block"), a = m("react.server.block"), _ = m("react.fundamental"), m("react.scope"), m("react.opaque.id"), v = m("react.debug_trace_mode"), m("react.offscreen"), l = m("react.legacy_hidden");
    }
    var D = typeof Symbol == "function" && Symbol.iterator, i = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function r(R) {
      for (var V = arguments.length, Y = new Array(V > 1 ? V - 1 : 0), z = 1; z < V; z++) Y[z - 1] = arguments[z];
      (function($, w, k) {
        var X = i.ReactDebugCurrentFrame, W = "";
        if (u) {
          var se = o(u.type), Z = u._owner;
          W += (function(F, te, ue) {
            var pe = "";
            if (te) {
              var He = te.fileName, Pe = He.replace(E, "");
              if (/^index\./.test(Pe)) {
                var de = He.match(E);
                if (de) {
                  var Ke = de[1];
                  Ke && (Pe = Ke.replace(E, "") + "/" + Pe);
                }
              }
              pe = " (at " + Pe + ":" + te.lineNumber + ")";
            } else ue && (pe = " (created by " + ue + ")");
            return `
    in ` + (F || "Unknown") + pe;
          })(se, u._source, Z && o(Z.type));
        }
        (W += X.getStackAddendum()) !== "" && (w += "%s", k = k.concat([W]));
        var M = k.map(function(F) {
          return "" + F;
        });
        M.unshift("Warning: " + w), Function.prototype.apply.call(console[$], console, M);
      })("error", R, Y);
    }
    var E = /^(.*)[\\\/]/, h = 1;
    function o(R) {
      if (R == null) return null;
      if (typeof R.tag == "number" && r("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof R == "function") return R.displayName || R.name || null;
      if (typeof R == "string") return R;
      switch (R) {
        case e.Fragment:
          return "Fragment";
        case n:
          return "Portal";
        case P:
          return "Profiler";
        case c:
          return "StrictMode";
        case U:
          return "Suspense";
        case p:
          return "SuspenseList";
      }
      if (typeof R == "object") switch (R.$$typeof) {
        case y:
          return "Context.Consumer";
        case T:
          return "Context.Provider";
        case C:
          return z = R, $ = R.render, w = "ForwardRef", k = $.displayName || $.name || "", z.displayName || (k !== "" ? w + "(" + k + ")" : w);
        case d:
          return o(R.type);
        case A:
          return o(R.render);
        case S:
          var V = (Y = R)._status === h ? Y._result : null;
          if (V) return o(V);
      }
      var Y, z, $, w, k;
      return null;
    }
    var f = {};
    i.ReactDebugCurrentFrame;
    var u = null;
    function I(R) {
      u = R;
    }
    var N, g, K = i.ReactCurrentOwner, q = Object.prototype.hasOwnProperty, x = { key: !0, ref: !0, __self: !0, __source: !0 };
    function ve(R, V, Y, z, $) {
      var w, k = {}, X = null, W = null;
      for (w in Y !== void 0 && (X = "" + Y), (function(M) {
        if (q.call(M, "key")) {
          var F = Object.getOwnPropertyDescriptor(M, "key").get;
          if (F && F.isReactWarning) return !1;
        }
        return M.key !== void 0;
      })(V) && (X = "" + V.key), (function(M) {
        if (q.call(M, "ref")) {
          var F = Object.getOwnPropertyDescriptor(M, "ref").get;
          if (F && F.isReactWarning) return !1;
        }
        return M.ref !== void 0;
      })(V) && (W = V.ref, (function(M) {
        typeof M.ref == "string" && K.current;
      })(V)), V) q.call(V, w) && !x.hasOwnProperty(w) && (k[w] = V[w]);
      if (R && R.defaultProps) {
        var se = R.defaultProps;
        for (w in se) k[w] === void 0 && (k[w] = se[w]);
      }
      if (X || W) {
        var Z = typeof R == "function" ? R.displayName || R.name || "Unknown" : R;
        X && (function(M, F) {
          var te = function() {
            N || (N = !0, r("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", F));
          };
          te.isReactWarning = !0, Object.defineProperty(M, "key", { get: te, configurable: !0 });
        })(k, Z), W && (function(M, F) {
          var te = function() {
            g || (g = !0, r("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", F));
          };
          te.isReactWarning = !0, Object.defineProperty(M, "ref", { get: te, configurable: !0 });
        })(k, Z);
      }
      return (function(M, F, te, ue, pe, He, Pe) {
        var de = { $$typeof: s, type: M, key: F, ref: te, props: Pe, _owner: He, _store: {} };
        return Object.defineProperty(de._store, "validated", { configurable: !1, enumerable: !1, writable: !0, value: !1 }), Object.defineProperty(de, "_self", { configurable: !1, enumerable: !1, writable: !1, value: ue }), Object.defineProperty(de, "_source", { configurable: !1, enumerable: !1, writable: !1, value: pe }), Object.freeze && (Object.freeze(de.props), Object.freeze(de)), de;
      })(R, X, W, $, z, K.current, k);
    }
    var j, B = i.ReactCurrentOwner;
    function ie(R) {
      u = R;
    }
    function he(R) {
      return typeof R == "object" && R !== null && R.$$typeof === s;
    }
    function Se() {
      if (B.current) {
        var R = o(B.current.type);
        if (R) return `

Check the render method of \`` + R + "`.";
      }
      return "";
    }
    i.ReactDebugCurrentFrame, j = !1;
    var Ie = {};
    function Oe(R, V) {
      if (R._store && !R._store.validated && R.key == null) {
        R._store.validated = !0;
        var Y = (function($) {
          var w = Se();
          if (!w) {
            var k = typeof $ == "string" ? $ : $.displayName || $.name;
            k && (w = `

Check the top-level render call using <` + k + ">.");
          }
          return w;
        })(V);
        if (!Ie[Y]) {
          Ie[Y] = !0;
          var z = "";
          R && R._owner && R._owner !== B.current && (z = " It was passed a child from " + o(R._owner.type) + "."), ie(R), r('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Y, z), ie(null);
        }
      }
    }
    function me(R, V) {
      if (typeof R == "object") {
        if (Array.isArray(R)) for (var Y = 0; Y < R.length; Y++) {
          var z = R[Y];
          he(z) && Oe(z, V);
        }
        else if (he(R)) R._store && (R._store.validated = !0);
        else if (R) {
          var $ = (function(X) {
            if (X === null || typeof X != "object") return null;
            var W = D && X[D] || X["@@iterator"];
            return typeof W == "function" ? W : null;
          })(R);
          if (typeof $ == "function" && $ !== R.entries) for (var w, k = $.call(R); !(w = k.next()).done; ) he(w.value) && Oe(w.value, V);
        }
      }
    }
    function Ce(R) {
      var V, Y = R.type;
      if (Y != null && typeof Y != "string") {
        if (typeof Y == "function") V = Y.propTypes;
        else {
          if (typeof Y != "object" || Y.$$typeof !== C && Y.$$typeof !== d) return;
          V = Y.propTypes;
        }
        if (V) {
          var z = o(Y);
          (function($, w, k, X, W) {
            var se = Function.call.bind(Object.prototype.hasOwnProperty);
            for (var Z in $) if (se($, Z)) {
              var M = void 0;
              try {
                if (typeof $[Z] != "function") {
                  var F = Error((X || "React class") + ": " + k + " type `" + Z + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof $[Z] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw F.name = "Invariant Violation", F;
                }
                M = $[Z](w, Z, X, k, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (te) {
                M = te;
              }
              !M || M instanceof Error || (I(W), r("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", X || "React class", k, Z, typeof M), I(null)), M instanceof Error && !(M.message in f) && (f[M.message] = !0, I(W), r("Failed %s type: %s", k, M.message), I(null));
            }
          })(V, R.props, "prop", z, R);
        } else Y.PropTypes === void 0 || j || (j = !0, r("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", o(Y) || "Unknown"));
        typeof Y.getDefaultProps != "function" || Y.getDefaultProps.isReactClassApproved || r("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Re(R, V, Y, z, $, w) {
      var k = (function(F) {
        return typeof F == "string" || typeof F == "function" || F === e.Fragment || F === P || F === v || F === c || F === U || F === p || F === l || typeof F == "object" && F !== null && (F.$$typeof === S || F.$$typeof === d || F.$$typeof === T || F.$$typeof === y || F.$$typeof === C || F.$$typeof === _ || F.$$typeof === A || F[0] === a);
      })(R);
      if (!k) {
        var X, W = "";
        (R === void 0 || typeof R == "object" && R !== null && Object.keys(R).length === 0) && (W += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), W += Se(), R === null ? X = "null" : Array.isArray(R) ? X = "array" : R !== void 0 && R.$$typeof === s ? (X = "<" + (o(R.type) || "Unknown") + " />", W = " Did you accidentally export a JSX literal instead of a component?") : X = typeof R, r("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", X, W);
      }
      var se = ve(R, V, Y, $, w);
      if (se == null) return se;
      if (k) {
        var Z = V.children;
        if (Z !== void 0) if (z) if (Array.isArray(Z)) {
          for (var M = 0; M < Z.length; M++) me(Z[M], R);
          Object.freeze && Object.freeze(Z);
        } else r("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
        else me(Z, R);
      }
      return R === e.Fragment ? (function(F) {
        for (var te = Object.keys(F.props), ue = 0; ue < te.length; ue++) {
          var pe = te[ue];
          if (pe !== "children" && pe !== "key") {
            ie(F), r("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", pe), ie(null);
            break;
          }
        }
        F.ref !== null && (ie(F), r("Invalid attribute `ref` supplied to `React.Fragment`."), ie(null));
      })(se) : Ce(se), se;
    }
    var ge = function(R, V, Y) {
      return Re(R, V, Y, !1);
    }, De = function(R, V, Y) {
      return Re(R, V, Y, !0);
    };
    e.jsx = ge, e.jsxs = De;
  })()), ze;
  var e;
}
var Me = (Xe || (Xe = 1, process.env.NODE_ENV === "production" ? Fe.exports = (function() {
  if ($e) return le;
  $e = 1;
  var e = Et, t = 60103;
  if (le.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var s = Symbol.for;
    t = s("react.element"), le.Fragment = s("react.fragment");
  }
  var n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, c = Object.prototype.hasOwnProperty, P = { key: !0, ref: !0, __self: !0, __source: !0 };
  function T(y, C, U) {
    var p, d = {}, S = null, A = null;
    for (p in U !== void 0 && (S = "" + U), C.key !== void 0 && (S = "" + C.key), C.ref !== void 0 && (A = C.ref), C) c.call(C, p) && !P.hasOwnProperty(p) && (d[p] = C[p]);
    if (y && y.defaultProps) for (p in C = y.defaultProps) d[p] === void 0 && (d[p] = C[p]);
    return { $$typeof: t, type: y, key: S, ref: A, props: d, _owner: n.current };
  }
  return le.jsx = T, le.jsxs = T, le;
})() : Fe.exports = ft()), Fe.exports);
const on = () => ({ ENV: "dev", HIVEMIND_ENV: "dev.hivery.ai", CY_TEST: "true", JEST: !1, ALLOW_PASSWORD_LOGIN: "true", CURATE_API_V1: "https://dev.hivery.ai/api/v1/curate", CURATE_API_V2: "https://dev.hivery.ai/api/v2/curate", INTERACTIVE_EDIT_API: "https://dev.hivery.ai/api/v1/ie", PREDICTION_API: "https://dev.hivery.ai/api/v1/prediction", SSDI_API: "https://dev.hivery.ai/api/v1/ssdi", SSDI_API_V2: "https://dev.hivery.ai/api/v2/ssdi", STRATEGY_API: "https://dev.hivery.ai/api/v1/strategies", AGENT_API: "https://dev.hivery.ai/api/v1/agent", FILES_API_HOST: "", AUTH0_CLIENT_ID: "pkcXkULYXQfYaFHpeb6BVPRoP0V1XIJN", AUTH0_DOMAIN: "auth.dev.hivery.ai", AUTH0_AUDIENCE: "propel-api-dev", PUSHER_APP_KEY: "1a2f9c6611892edf8b3f", PUSHER_CLUSTER: "us3", PUSHER_IE_APP_KEY: "1a2f9c6611892edf8b3f", PUSHER_IE_CLUSTER: "us3", UNLEASH_URL: "https://zero.hivery.ai/unleash/api/frontend", UNLEASH_TOKEN: "*:development.73b148c1e2fe6b2e0aeedfe610ee2d6e8c5890dea9f00e6a08c8638d", UNLEASH_ENV: "development", OTEL_KEY: "", OTEL_COLLECTOR_URL: "https://dev.hivery.ai/collect", OTEL_SERVICE_NAME: "", PRODUCT_IMAGE_HOST: "dev", AZURE_CDN_DOMAIN: "https://app.dev.hivery.ai" }), yt = (e) => {
  switch (e) {
    case "text/csv":
      return "csv";
    case "image/jpeg":
      return "jpeg";
    case "application/json":
      return "json";
    case "text/markdown":
      return "md";
    case "application/vnd.oasis.opendocument.presentation":
      return "odp";
    case "application/vnd.oasis.opendocument.spreadsheet":
      return "ods";
    case "image/png":
      return "png";
    case "application/pdf":
      return "pdg";
    case "application/vnd.ms-powerpoint":
      return "ppt";
    case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      return "pptx";
    case "application/vnd.rar":
      return "rar";
    case "application/rtf":
      return "rtf";
    case "application/x-tar":
      return "tar";
    case "text/plain":
      return "txt";
    case "application/vnd.ms-excel":
      return "xls";
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      return "xlsx";
    case "application/zip":
    case "application/x-zip-compressed":
      return "zip";
    default:
      return void console.warn("unsupported mime type", e);
  }
}, Ge = (e, t) => {
  let s, n = e;
  try {
    let c = t.split(".");
    for (c.length === 0 && (c = [t]); c.length > 0; ) {
      if (s = c.shift(), !s) return;
      if (Array.isArray(n[s])) {
        n = [];
        const P = c.splice(-1).join(".");
        for (let T = 0, y = e[s].length; T < y; T++) n.push(Ge(e[s][T], P));
      } else n = n[s];
    }
    return n;
  } catch (c) {
    return void console.error("unexpected error occurred while trying to find value from pointer", e, t, c);
  }
}, pn = (e, t, s) => {
  let n, c = -1;
  for (let P = 0, T = e?.length; P < T; P += 1) if (n = Ge(e[P], t), Array.isArray(n)) {
    if (n.indexOf(s) !== -1) {
      c = P;
      break;
    }
  } else if (n === s) {
    c = P;
    break;
  }
  return c;
}, mt = (e, t, s = !1) => {
  const n = [...e].sort((c, P) => {
    let T = Ge(c, t.toString()), y = Ge(P, t.toString());
    return typeof T == "string" && (T = T.toLocaleLowerCase()), typeof y == "string" && (y = y.toLocaleLowerCase()), T === y ? 0 : T < y ? -1 : 1;
  });
  return s ? n.reverse() : n;
};
var Ze, Be, We, oe = {}, ee = {};
function Te() {
  if (Ze) return ee;
  Ze = 1;
  var e = ee.ValidationError = function(a, _, v, l, m, D) {
    if (Array.isArray(l) ? (this.path = l, this.property = l.reduce(function(r, E) {
      return r + y(E);
    }, "instance")) : l !== void 0 && (this.property = l), a && (this.message = a), v) {
      var i = v.$id || v.id;
      this.schema = i || v;
    }
    _ !== void 0 && (this.instance = _), this.name = m, this.argument = D, this.stack = this.toString();
  };
  e.prototype.toString = function() {
    return this.property + " " + this.message;
  };
  var t = ee.ValidatorResult = function(a, _, v, l) {
    this.instance = a, this.schema = _, this.options = v, this.path = l.path, this.propertyPath = l.propertyPath, this.errors = [], this.throwError = v && v.throwError, this.throwFirst = v && v.throwFirst, this.throwAll = v && v.throwAll, this.disableFormat = v && v.disableFormat === !0;
  };
  function s(a, _) {
    return _ + ": " + a.toString() + `
`;
  }
  function n(a) {
    typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, n), this.instance = a.instance, this.schema = a.schema, this.options = a.options, this.errors = a.errors;
  }
  t.prototype.addError = function(a) {
    var _;
    if (typeof a == "string") _ = new e(a, this.instance, this.schema, this.path);
    else {
      if (!a) throw new Error("Missing error detail");
      if (!a.message) throw new Error("Missing error message");
      if (!a.name) throw new Error("Missing validator type");
      _ = new e(a.message, this.instance, this.schema, this.path, a.name, a.argument);
    }
    if (this.errors.push(_), this.throwFirst) throw new n(this);
    if (this.throwError) throw _;
    return _;
  }, t.prototype.importErrors = function(a) {
    typeof a == "string" || a && a.validatorType ? this.addError(a) : a && a.errors && (this.errors = this.errors.concat(a.errors));
  }, t.prototype.toString = function(a) {
    return this.errors.map(s).join("");
  }, Object.defineProperty(t.prototype, "valid", { get: function() {
    return !this.errors.length;
  } }), ee.ValidatorResultError = n, n.prototype = new Error(), n.prototype.constructor = n, n.prototype.name = "Validation Error";
  var c = ee.SchemaError = function a(_, v) {
    this.message = _, this.schema = v, Error.call(this, _), typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, a);
  };
  c.prototype = Object.create(Error.prototype, { constructor: { value: c, enumerable: !1 }, name: { value: "SchemaError", enumerable: !1 } });
  var P = ee.SchemaContext = function(a, _, v, l, m) {
    this.schema = a, this.options = _, Array.isArray(v) ? (this.path = v, this.propertyPath = v.reduce(function(D, i) {
      return D + y(i);
    }, "instance")) : this.propertyPath = v, this.base = l, this.schemas = m;
  };
  P.prototype.resolve = function(a) {
    return A(this.base, a);
  }, P.prototype.makeChild = function(a, _) {
    var v = _ === void 0 ? this.path : this.path.concat([_]), l = a.$id || a.id;
    let m = A(this.base, l || "");
    var D = new P(a, this.options, v, m, Object.create(this.schemas));
    return l && !D.schemas[m] && (D.schemas[m] = a), D;
  };
  var T = ee.FORMAT_REGEXPS = { "date-time": /^\d{4}-(?:0[0-9]{1}|1[0-2]{1})-(3[01]|0[1-9]|[12][0-9])[tT ](2[0-4]|[01][0-9]):([0-5][0-9]):(60|[0-5][0-9])(\.\d+)?([zZ]|[+-]([0-5][0-9]):(60|[0-5][0-9]))$/, date: /^\d{4}-(?:0[0-9]{1}|1[0-2]{1})-(3[01]|0[1-9]|[12][0-9])$/, time: /^(2[0-4]|[01][0-9]):([0-5][0-9]):(60|[0-5][0-9])$/, duration: /P(T\d+(H(\d+M(\d+S)?)?|M(\d+S)?|S)|\d+(D|M(\d+D)?|Y(\d+M(\d+D)?)?)(T\d+(H(\d+M(\d+S)?)?|M(\d+S)?|S))?|\d+W)/i, email: /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/, "idn-email": /^("(?:[!#-\[\]-\u{10FFFF}]|\\[\t -\u{10FFFF}])*"|[!#-'*+\-/-9=?A-Z\^-\u{10FFFF}](?:\.?[!#-'*+\-/-9=?A-Z\^-\u{10FFFF}])*)@([!#-'*+\-/-9=?A-Z\^-\u{10FFFF}](?:\.?[!#-'*+\-/-9=?A-Z\^-\u{10FFFF}])*|\[[!-Z\^-\u{10FFFF}]*\])$/u, "ip-address": /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/, ipv6: /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/, uri: /^[a-zA-Z][a-zA-Z0-9+.-]*:[^\s]*$/, "uri-reference": /^(((([A-Za-z][+\-.0-9A-Za-z]*(:%[0-9A-Fa-f]{2}|:[!$&-.0-;=?-Z_a-z~]|[/?])|\?)(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|([A-Za-z][+\-.0-9A-Za-z]*:?)?)|([A-Za-z][+\-.0-9A-Za-z]*:)?\/((%[0-9A-Fa-f]{2}|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?[/?]|[!$&-.0-;=?-Z_a-z~])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|(\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?)?))#(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|(([A-Za-z][+\-.0-9A-Za-z]*)?%[0-9A-Fa-f]{2}|[!$&-.0-9;=@_~]|[A-Za-z][+\-.0-9A-Za-z]*[!$&-*,;=@_~])(%[0-9A-Fa-f]{2}|[!$&-.0-9;=@-Z_a-z~])*((([/?](%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*)?#|[/?])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*)?|([A-Za-z][+\-.0-9A-Za-z]*(:%[0-9A-Fa-f]{2}|:[!$&-.0-;=?-Z_a-z~]|[/?])|\?)(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|([A-Za-z][+\-.0-9A-Za-z]*:)?\/((%[0-9A-Fa-f]{2}|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?[/?]|[!$&-.0-;=?-Z_a-z~])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+(:\d*)?|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?:\d*|\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)?|[A-Za-z][+\-.0-9A-Za-z]*:?)?$/, iri: /^[a-zA-Z][a-zA-Z0-9+.-]*:[^\s]*$/, "iri-reference": /^(((([A-Za-z][+\-.0-9A-Za-z]*(:%[0-9A-Fa-f]{2}|:[!$&-.0-;=?-Z_a-z~-\u{10FFFF}]|[/?])|\?)(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*|([A-Za-z][+\-.0-9A-Za-z]*:?)?)|([A-Za-z][+\-.0-9A-Za-z]*:)?\/((%[0-9A-Fa-f]{2}|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~-\u{10FFFF}])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~-\u{10FFFF}]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?[/?]|[!$&-.0-;=?-Z_a-z~-\u{10FFFF}])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*|(\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~-\u{10FFFF}])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~-\u{10FFFF}]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?)?))#(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*|(([A-Za-z][+\-.0-9A-Za-z]*)?%[0-9A-Fa-f]{2}|[!$&-.0-9;=@_~-\u{10FFFF}]|[A-Za-z][+\-.0-9A-Za-z]*[!$&-*,;=@_~-\u{10FFFF}])(%[0-9A-Fa-f]{2}|[!$&-.0-9;=@-Z_a-z~-\u{10FFFF}])*((([/?](%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*)?#|[/?])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*)?|([A-Za-z][+\-.0-9A-Za-z]*(:%[0-9A-Fa-f]{2}|:[!$&-.0-;=?-Z_a-z~-\u{10FFFF}]|[/?])|\?)(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*|([A-Za-z][+\-.0-9A-Za-z]*:)?\/((%[0-9A-Fa-f]{2}|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~-\u{10FFFF}])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~-\u{10FFFF}]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?[/?]|[!$&-.0-;=?-Z_a-z~-\u{10FFFF}])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~-\u{10FFFF}])+(:\d*)?|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~-\u{10FFFF}]+)?|[.0-:A-Fa-f]+)\])?:\d*|\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~-\u{10FFFF}]+)?|[.0-:A-Fa-f]+)\])?)?|[A-Za-z][+\-.0-9A-Za-z]*:?)?$/u, uuid: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i, "uri-template": /(%[0-9a-f]{2}|[!#$&(-;=?@\[\]_a-z~]|\{[!#&+,./;=?@|]?(%[0-9a-f]{2}|[0-9_a-z])(\.?(%[0-9a-f]{2}|[0-9_a-z]))*(:[1-9]\d{0,3}|\*)?(,(%[0-9a-f]{2}|[0-9_a-z])(\.?(%[0-9a-f]{2}|[0-9_a-z]))*(:[1-9]\d{0,3}|\*)?)*\})*/iu, "json-pointer": /^(\/([\x00-\x2e0-@\[-}\x7f]|~[01])*)*$/iu, "relative-json-pointer": /^\d+(#|(\/([\x00-\x2e0-@\[-}\x7f]|~[01])*)*)$/iu, hostname: /^(?=.{1,255}$)[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?(?:\.[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?)*\.?$/, "host-name": /^(?=.{1,255}$)[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?(?:\.[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?)*\.?$/, "utc-millisec": function(a) {
    return typeof a == "string" && parseFloat(a) === parseInt(a, 10) && !isNaN(a);
  }, regex: function(a) {
    var _ = !0;
    try {
      new RegExp(a);
    } catch {
      _ = !1;
    }
    return _;
  }, style: /[\r\n\t ]*[^\r\n\t ][^:]*:[\r\n\t ]*[^\r\n\t ;]*[\r\n\t ]*;?/, color: /^(#?([0-9A-Fa-f]{3}){1,2}\b|aqua|black|blue|fuchsia|gray|green|lime|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow|(rgb\(\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*\))|(rgb\(\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*\)))$/, phone: /^\+(?:[0-9] ?){6,14}[0-9]$/, alpha: /^[a-zA-Z]+$/, alphanumeric: /^[a-zA-Z0-9]+$/ };
  T.regexp = T.regex, T.pattern = T.regex, T.ipv4 = T["ip-address"], ee.isFormat = function(a, _, v) {
    if (typeof a == "string" && T[_] !== void 0) {
      if (T[_] instanceof RegExp) return T[_].test(a);
      if (typeof T[_] == "function") return T[_](a);
    } else if (v && v.customFormats && typeof v.customFormats[_] == "function") return v.customFormats[_](a);
    return !0;
  };
  var y = ee.makeSuffix = function(a) {
    return (a = a.toString()).match(/[.\s\[\]]/) || a.match(/^[\d]/) ? a.match(/^\d+$/) ? "[" + a + "]" : "[" + JSON.stringify(a) + "]" : "." + a;
  };
  function C(a, _, v, l) {
    typeof v == "object" ? _[l] = d(a[l], v) : a.indexOf(v) === -1 && _.push(v);
  }
  function U(a, _, v) {
    _[v] = a[v];
  }
  function p(a, _, v, l) {
    typeof _[l] == "object" && _[l] && a[l] ? v[l] = d(a[l], _[l]) : v[l] = _[l];
  }
  function d(a, _) {
    var v = Array.isArray(_), l = v && [] || {};
    return v ? (a = a || [], l = l.concat(a), _.forEach(C.bind(null, a, l))) : (a && typeof a == "object" && Object.keys(a).forEach(U.bind(null, a, l)), Object.keys(_).forEach(p.bind(null, a, _, l))), l;
  }
  function S(a) {
    return "/" + encodeURIComponent(a).replace(/~/g, "%7E");
  }
  ee.deepCompareStrict = function a(_, v) {
    if (typeof _ != typeof v) return !1;
    if (Array.isArray(_)) return !!Array.isArray(v) && _.length === v.length && _.every(function(D, i) {
      return a(_[i], v[i]);
    });
    if (typeof _ == "object") {
      if (!_ || !v) return _ === v;
      var l = Object.keys(_), m = Object.keys(v);
      return l.length === m.length && l.every(function(D) {
        return a(_[D], v[D]);
      });
    }
    return _ === v;
  }, ee.deepMerge = d, ee.objectGetPath = function(a, _) {
    for (var v, l = _.split("/").slice(1); typeof (v = l.shift()) == "string"; ) {
      var m = decodeURIComponent(v.replace(/~0/, "~").replace(/~1/g, "/"));
      if (!(m in a)) return;
      a = a[m];
    }
    return a;
  }, ee.encodePath = function(a) {
    return a.map(S).join("");
  }, ee.getDecimalPlaces = function(a) {
    var _ = 0;
    if (isNaN(a)) return _;
    typeof a != "number" && (a = Number(a));
    var v = a.toString().split("e");
    if (v.length === 2) {
      if (v[1][0] !== "-") return _;
      _ = Number(v[1].slice(1));
    }
    var l = v[0].split(".");
    return l.length === 2 && (_ += l[1].length), _;
  }, ee.isSchema = function(a) {
    return typeof a == "object" && a || typeof a == "boolean";
  };
  var A = ee.resolveUrl = function(a, _) {
    const v = new URL(_, new URL(a, "resolve://"));
    if (v.protocol === "resolve:") {
      const { pathname: l, search: m, hash: D } = v;
      return l + m + D;
    }
    return v.toString();
  };
  return ee;
}
var Je, Qe, et, tt, Ve = {};
function qe() {
  if (Je) return Ve;
  Je = 1;
  var e = Te();
  function t(s, n) {
    this.id = s, this.ref = n;
  }
  return Ve.SchemaScanResult = t, Ve.scan = function(s, n) {
    function c(U, p) {
      if (!p || typeof p != "object") return;
      if (p.$ref) {
        let a = e.resolveUrl(U, p.$ref);
        return void (C[a] = C[a] ? C[a] + 1 : 0);
      }
      var d = p.$id || p.id;
      let S = e.resolveUrl(U, d);
      var A = d ? S : U;
      if (A) {
        if (A.indexOf("#") < 0 && (A += "#"), y[A]) {
          if (!e.deepCompareStrict(y[A], p)) throw new Error("Schema <" + A + "> already exists with different definition");
          return y[A];
        }
        y[A] = p, A[A.length - 1] == "#" && (y[A.substring(0, A.length - 1)] = p);
      }
      P(A + "/items", Array.isArray(p.items) ? p.items : [p.items]), P(A + "/extends", Array.isArray(p.extends) ? p.extends : [p.extends]), c(A + "/additionalItems", p.additionalItems), T(A + "/properties", p.properties), c(A + "/additionalProperties", p.additionalProperties), T(A + "/definitions", p.definitions), T(A + "/patternProperties", p.patternProperties), T(A + "/dependencies", p.dependencies), P(A + "/disallow", p.disallow), P(A + "/allOf", p.allOf), P(A + "/anyOf", p.anyOf), P(A + "/oneOf", p.oneOf), c(A + "/not", p.not);
    }
    function P(U, p) {
      if (Array.isArray(p)) for (var d = 0; d < p.length; d++) c(U + "/" + d, p[d]);
    }
    function T(U, p) {
      if (p && typeof p == "object") for (var d in p) c(U + "/" + d, p[d]);
    }
    var y = {}, C = {};
    return c(s, n), new t(y, C);
  }, Ve;
}
function Rt() {
  if (et) return Qe;
  et = 1;
  var e = (function() {
    if (We) return Be;
    We = 1;
    var p = Te(), d = p.ValidatorResult, S = p.SchemaError, A = { ignoreProperties: { id: !0, default: !0, description: !0, title: !0, additionalItems: !0, then: !0, else: !0, $schema: !0, $ref: !0, extends: !0 } }, a = A.validators = {};
    function _(i, r, E, h, o) {
      var f = r.throwError, u = r.throwAll;
      r.throwError = !1, r.throwAll = !1;
      var I = this.validateSchema(i, o, r, E);
      return r.throwError = f, r.throwAll = u, !I.valid && h instanceof Function && h(I), I.valid;
    }
    function v(i, r) {
      if (Object.hasOwnProperty.call(i, r)) return i[r];
      if (r in i) {
        for (; i = Object.getPrototypeOf(i); ) if (Object.propertyIsEnumerable.call(i, r)) return i[r];
      }
    }
    function l(i, r, E, h, o, f) {
      if (this.types.object(i) && (!r.properties || r.properties[o] === void 0)) if (r.additionalProperties === !1) f.addError({ name: "additionalProperties", argument: o, message: "is not allowed to have the additional property " + JSON.stringify(o) });
      else {
        var u = r.additionalProperties || {};
        typeof E.preValidateProperty == "function" && E.preValidateProperty(i, o, u, E, h);
        var I = this.validateSchema(i[o], u, E, h.makeChild(u, o));
        I.instance !== f.instance[o] && (f.instance[o] = I.instance), f.importErrors(I);
      }
    }
    a.type = function(i, r, E, h) {
      if (i === void 0) return null;
      var o = new d(i, r, E, h), f = Array.isArray(r.type) ? r.type : [r.type];
      if (!f.some(this.testType.bind(this, i, r, E, h))) {
        var u = f.map(function(I) {
          if (I) {
            var N = I.$id || I.id;
            return N ? "<" + N + ">" : I + "";
          }
        });
        o.addError({ name: "type", argument: u, message: "is not of a type(s) " + u });
      }
      return o;
    }, a.anyOf = function(i, r, E, h) {
      if (i === void 0) return null;
      var o = new d(i, r, E, h), f = new d(i, r, E, h);
      if (!Array.isArray(r.anyOf)) throw new S("anyOf must be an array");
      if (!r.anyOf.some(_.bind(this, i, E, h, function(I) {
        f.importErrors(I);
      }))) {
        var u = r.anyOf.map(function(I, N) {
          var g = I.$id || I.id;
          return g ? "<" + g + ">" : I.title && JSON.stringify(I.title) || I.$ref && "<" + I.$ref + ">" || "[subschema " + N + "]";
        });
        E.nestedErrors && o.importErrors(f), o.addError({ name: "anyOf", argument: u, message: "is not any of " + u.join(",") });
      }
      return o;
    }, a.allOf = function(i, r, E, h) {
      if (i === void 0) return null;
      if (!Array.isArray(r.allOf)) throw new S("allOf must be an array");
      var o = new d(i, r, E, h), f = this;
      return r.allOf.forEach(function(u, I) {
        var N = f.validateSchema(i, u, E, h);
        if (!N.valid) {
          var g = u.$id || u.id || u.title && JSON.stringify(u.title) || u.$ref && "<" + u.$ref + ">" || "[subschema " + I + "]";
          o.addError({ name: "allOf", argument: { id: g, length: N.errors.length, valid: N }, message: "does not match allOf schema " + g + " with " + N.errors.length + " error[s]:" }), o.importErrors(N);
        }
      }), o;
    }, a.oneOf = function(i, r, E, h) {
      if (i === void 0) return null;
      if (!Array.isArray(r.oneOf)) throw new S("oneOf must be an array");
      var o = new d(i, r, E, h), f = new d(i, r, E, h), u = r.oneOf.filter(_.bind(this, i, E, h, function(N) {
        f.importErrors(N);
      })).length, I = r.oneOf.map(function(N, g) {
        return N.$id || N.id || N.title && JSON.stringify(N.title) || N.$ref && "<" + N.$ref + ">" || "[subschema " + g + "]";
      });
      return u !== 1 && (E.nestedErrors && o.importErrors(f), o.addError({ name: "oneOf", argument: I, message: "is not exactly one from " + I.join(",") })), o;
    }, a.if = function(i, r, E, h) {
      if (i === void 0) return null;
      if (!p.isSchema(r.if)) throw new Error('Expected "if" keyword to be a schema');
      var o, f = _.call(this, i, E, h, null, r.if), u = new d(i, r, E, h);
      if (f) {
        if (r.then === void 0) return;
        if (!p.isSchema(r.then)) throw new Error('Expected "then" keyword to be a schema');
        o = this.validateSchema(i, r.then, E, h.makeChild(r.then)), u.importErrors(o);
      } else {
        if (r.else === void 0) return;
        if (!p.isSchema(r.else)) throw new Error('Expected "else" keyword to be a schema');
        o = this.validateSchema(i, r.else, E, h.makeChild(r.else)), u.importErrors(o);
      }
      return u;
    }, a.propertyNames = function(i, r, E, h) {
      if (this.types.object(i)) {
        var o = new d(i, r, E, h), f = r.propertyNames !== void 0 ? r.propertyNames : {};
        if (!p.isSchema(f)) throw new S('Expected "propertyNames" to be a schema (object or boolean)');
        for (var u in i) if (v(i, u) !== void 0) {
          var I = this.validateSchema(u, f, E, h.makeChild(f));
          o.importErrors(I);
        }
        return o;
      }
    }, a.properties = function(i, r, E, h) {
      if (this.types.object(i)) {
        var o = new d(i, r, E, h), f = r.properties || {};
        for (var u in f) {
          var I = f[u];
          if (I !== void 0) {
            if (I === null) throw new S('Unexpected null, expected schema in "properties"');
            typeof E.preValidateProperty == "function" && E.preValidateProperty(i, u, I, E, h);
            var N = v(i, u), g = this.validateSchema(N, I, E, h.makeChild(I, u));
            g.instance !== o.instance[u] && (o.instance[u] = g.instance), o.importErrors(g);
          }
        }
        return o;
      }
    }, a.patternProperties = function(i, r, E, h) {
      if (this.types.object(i)) {
        var o = new d(i, r, E, h), f = r.patternProperties || {};
        for (var u in i) {
          var I = !0;
          for (var N in f) {
            var g = f[N];
            if (g !== void 0) {
              if (g === null) throw new S('Unexpected null, expected schema in "patternProperties"');
              try {
                var K = new RegExp(N, "u");
              } catch {
                K = new RegExp(N);
              }
              if (K.test(u)) {
                I = !1, typeof E.preValidateProperty == "function" && E.preValidateProperty(i, u, g, E, h);
                var q = this.validateSchema(i[u], g, E, h.makeChild(g, u));
                q.instance !== o.instance[u] && (o.instance[u] = q.instance), o.importErrors(q);
              }
            }
          }
          I && l.call(this, i, r, E, h, u, o);
        }
        return o;
      }
    }, a.additionalProperties = function(i, r, E, h) {
      if (this.types.object(i)) {
        if (r.patternProperties) return null;
        var o = new d(i, r, E, h);
        for (var f in i) l.call(this, i, r, E, h, f, o);
        return o;
      }
    }, a.minProperties = function(i, r, E, h) {
      if (this.types.object(i)) {
        var o = new d(i, r, E, h);
        return Object.keys(i).length >= r.minProperties || o.addError({ name: "minProperties", argument: r.minProperties, message: "does not meet minimum property length of " + r.minProperties }), o;
      }
    }, a.maxProperties = function(i, r, E, h) {
      if (this.types.object(i)) {
        var o = new d(i, r, E, h);
        return Object.keys(i).length <= r.maxProperties || o.addError({ name: "maxProperties", argument: r.maxProperties, message: "does not meet maximum property length of " + r.maxProperties }), o;
      }
    }, a.items = function(i, r, E, h) {
      var o = this;
      if (this.types.array(i) && r.items !== void 0) {
        var f = new d(i, r, E, h);
        return i.every(function(u, I) {
          if (Array.isArray(r.items)) var N = r.items[I] === void 0 ? r.additionalItems : r.items[I];
          else N = r.items;
          if (N === void 0) return !0;
          if (N === !1) return f.addError({ name: "items", message: "additionalItems not permitted" }), !1;
          var g = o.validateSchema(u, N, E, h.makeChild(N, I));
          return g.instance !== f.instance[I] && (f.instance[I] = g.instance), f.importErrors(g), !0;
        }), f;
      }
    }, a.contains = function(i, r, E, h) {
      var o = this;
      if (this.types.array(i) && r.contains !== void 0) {
        if (!p.isSchema(r.contains)) throw new Error('Expected "contains" keyword to be a schema');
        var f = new d(i, r, E, h);
        return i.some(function(u, I) {
          return o.validateSchema(u, r.contains, E, h.makeChild(r.contains, I)).errors.length === 0;
        }) === !1 && f.addError({ name: "contains", argument: r.contains, message: "must contain an item matching given schema" }), f;
      }
    }, a.minimum = function(i, r, E, h) {
      if (this.types.number(i)) {
        var o = new d(i, r, E, h);
        return r.exclusiveMinimum && r.exclusiveMinimum === !0 ? i > r.minimum || o.addError({ name: "minimum", argument: r.minimum, message: "must be greater than " + r.minimum }) : i >= r.minimum || o.addError({ name: "minimum", argument: r.minimum, message: "must be greater than or equal to " + r.minimum }), o;
      }
    }, a.maximum = function(i, r, E, h) {
      if (this.types.number(i)) {
        var o = new d(i, r, E, h);
        return r.exclusiveMaximum && r.exclusiveMaximum === !0 ? i < r.maximum || o.addError({ name: "maximum", argument: r.maximum, message: "must be less than " + r.maximum }) : i <= r.maximum || o.addError({ name: "maximum", argument: r.maximum, message: "must be less than or equal to " + r.maximum }), o;
      }
    }, a.exclusiveMinimum = function(i, r, E, h) {
      if (typeof r.exclusiveMinimum != "boolean" && this.types.number(i)) {
        var o = new d(i, r, E, h);
        return i > r.exclusiveMinimum || o.addError({ name: "exclusiveMinimum", argument: r.exclusiveMinimum, message: "must be strictly greater than " + r.exclusiveMinimum }), o;
      }
    }, a.exclusiveMaximum = function(i, r, E, h) {
      if (typeof r.exclusiveMaximum != "boolean" && this.types.number(i)) {
        var o = new d(i, r, E, h);
        return i < r.exclusiveMaximum || o.addError({ name: "exclusiveMaximum", argument: r.exclusiveMaximum, message: "must be strictly less than " + r.exclusiveMaximum }), o;
      }
    };
    var m = function(i, r, E, h, o, f) {
      if (this.types.number(i)) {
        var u = r[o];
        if (u == 0) throw new S(o + " cannot be zero");
        var I = new d(i, r, E, h), N = p.getDecimalPlaces(i), g = p.getDecimalPlaces(u), K = Math.max(N, g), q = Math.pow(10, K);
        return Math.round(i * q) % Math.round(u * q) !== 0 && I.addError({ name: o, argument: u, message: f + JSON.stringify(u) }), I;
      }
    };
    function D(i, r, E) {
      var h, o = E.length;
      for (h = r + 1; h < o; h++) if (p.deepCompareStrict(i, E[h])) return !1;
      return !0;
    }
    return a.multipleOf = function(i, r, E, h) {
      return m.call(this, i, r, E, h, "multipleOf", "is not a multiple of (divisible by) ");
    }, a.divisibleBy = function(i, r, E, h) {
      return m.call(this, i, r, E, h, "divisibleBy", "is not divisible by (multiple of) ");
    }, a.required = function(i, r, E, h) {
      var o = new d(i, r, E, h);
      return i === void 0 && r.required === !0 ? o.addError({ name: "required", message: "is required" }) : this.types.object(i) && Array.isArray(r.required) && r.required.forEach(function(f) {
        v(i, f) === void 0 && o.addError({ name: "required", argument: f, message: "requires property " + JSON.stringify(f) });
      }), o;
    }, a.pattern = function(i, r, E, h) {
      if (this.types.string(i)) {
        var o = new d(i, r, E, h), f = r.pattern;
        try {
          var u = new RegExp(f, "u");
        } catch {
          u = new RegExp(f);
        }
        return i.match(u) || o.addError({ name: "pattern", argument: r.pattern, message: "does not match pattern " + JSON.stringify(r.pattern.toString()) }), o;
      }
    }, a.format = function(i, r, E, h) {
      if (i !== void 0) {
        var o = new d(i, r, E, h);
        return o.disableFormat || p.isFormat(i, r.format, this) || o.addError({ name: "format", argument: r.format, message: "does not conform to the " + JSON.stringify(r.format) + " format" }), o;
      }
    }, a.minLength = function(i, r, E, h) {
      if (this.types.string(i)) {
        var o = new d(i, r, E, h), f = i.match(/[\uDC00-\uDFFF]/g);
        return i.length - (f ? f.length : 0) >= r.minLength || o.addError({ name: "minLength", argument: r.minLength, message: "does not meet minimum length of " + r.minLength }), o;
      }
    }, a.maxLength = function(i, r, E, h) {
      if (this.types.string(i)) {
        var o = new d(i, r, E, h), f = i.match(/[\uDC00-\uDFFF]/g);
        return i.length - (f ? f.length : 0) <= r.maxLength || o.addError({ name: "maxLength", argument: r.maxLength, message: "does not meet maximum length of " + r.maxLength }), o;
      }
    }, a.minItems = function(i, r, E, h) {
      if (this.types.array(i)) {
        var o = new d(i, r, E, h);
        return i.length >= r.minItems || o.addError({ name: "minItems", argument: r.minItems, message: "does not meet minimum length of " + r.minItems }), o;
      }
    }, a.maxItems = function(i, r, E, h) {
      if (this.types.array(i)) {
        var o = new d(i, r, E, h);
        return i.length <= r.maxItems || o.addError({ name: "maxItems", argument: r.maxItems, message: "does not meet maximum length of " + r.maxItems }), o;
      }
    }, a.uniqueItems = function(i, r, E, h) {
      if (r.uniqueItems === !0 && this.types.array(i)) {
        var o = new d(i, r, E, h);
        return i.every(D) || o.addError({ name: "uniqueItems", message: "contains duplicate item" }), o;
      }
    }, a.dependencies = function(i, r, E, h) {
      if (this.types.object(i)) {
        var o = new d(i, r, E, h);
        for (var f in r.dependencies) if (i[f] !== void 0) {
          var u = r.dependencies[f], I = h.makeChild(u, f);
          if (typeof u == "string" && (u = [u]), Array.isArray(u)) u.forEach(function(g) {
            i[g] === void 0 && o.addError({ name: "dependencies", argument: I.propertyPath, message: "property " + g + " not found, required by " + I.propertyPath });
          });
          else {
            var N = this.validateSchema(i, u, E, I);
            o.instance !== N.instance && (o.instance = N.instance), N && N.errors.length && (o.addError({ name: "dependencies", argument: I.propertyPath, message: "does not meet dependency required by " + I.propertyPath }), o.importErrors(N));
          }
        }
        return o;
      }
    }, a.enum = function(i, r, E, h) {
      if (i === void 0) return null;
      if (!Array.isArray(r.enum)) throw new S("enum expects an array", r);
      var o = new d(i, r, E, h);
      return r.enum.some(p.deepCompareStrict.bind(null, i)) || o.addError({ name: "enum", argument: r.enum, message: "is not one of enum values: " + r.enum.map(String).join(",") }), o;
    }, a.const = function(i, r, E, h) {
      if (i === void 0) return null;
      var o = new d(i, r, E, h);
      return p.deepCompareStrict(r.const, i) || o.addError({ name: "const", argument: r.const, message: "does not exactly match expected constant: " + r.const }), o;
    }, a.not = a.disallow = function(i, r, E, h) {
      var o = this;
      if (i === void 0) return null;
      var f = new d(i, r, E, h), u = r.not || r.disallow;
      return u ? (Array.isArray(u) || (u = [u]), u.forEach(function(I) {
        if (o.testType(i, r, E, h, I)) {
          var N = I && (I.$id || I.id) || I;
          f.addError({ name: "not", argument: N, message: "is of prohibited type " + N });
        }
      }), f) : null;
    }, Be = A;
  })(), t = Te(), s = qe().scan, n = t.ValidatorResult, c = t.ValidatorResultError, P = t.SchemaError, T = t.SchemaContext, y = function p() {
    this.customFormats = Object.create(p.prototype.customFormats), this.schemas = {}, this.unresolvedRefs = [], this.types = Object.create(U), this.attributes = Object.create(e.validators);
  };
  function C(p) {
    var d = typeof p == "string" ? p : p.$ref;
    return typeof d == "string" && d;
  }
  y.prototype.customFormats = {}, y.prototype.schemas = null, y.prototype.types = null, y.prototype.attributes = null, y.prototype.unresolvedRefs = null, y.prototype.addSchema = function(p, d) {
    var S = this;
    if (!p) return null;
    var A = s(d || "/", p), a = d || p.$id || p.id;
    for (var _ in A.id) this.schemas[_] = A.id[_];
    for (var _ in A.ref) this.unresolvedRefs.push(_);
    return this.unresolvedRefs = this.unresolvedRefs.filter(function(v) {
      return S.schemas[v] === void 0;
    }), this.schemas[a];
  }, y.prototype.addSubSchemaArray = function(p, d) {
    if (Array.isArray(d)) for (var S = 0; S < d.length; S++) this.addSubSchema(p, d[S]);
  }, y.prototype.addSubSchemaObject = function(p, d) {
    if (d && typeof d == "object") for (var S in d) this.addSubSchema(p, d[S]);
  }, y.prototype.setSchemas = function(p) {
    this.schemas = p;
  }, y.prototype.getSchema = function(p) {
    return this.schemas[p];
  }, y.prototype.validate = function(p, d, S, A) {
    if (typeof d != "boolean" && typeof d != "object" || d === null) throw new P("Expected `schema` to be an object or boolean");
    S || (S = {});
    var a = d.$id || d.id;
    let _ = t.resolveUrl(S.base, a || "");
    if (!A) {
      (A = new T(d, S, [], _, Object.create(this.schemas))).schemas[_] || (A.schemas[_] = d);
      var v = s(_, d);
      for (var l in v.id) {
        var m = v.id[l];
        A.schemas[l] = m;
      }
    }
    var D;
    if (S.required && p === void 0) return (D = new n(p, d, S, A)).addError("is required, but is undefined"), D;
    if (!(D = this.validateSchema(p, d, S, A))) throw new Error("Result undefined");
    if (S.throwAll && D.errors.length) throw new c(D);
    return D;
  }, y.prototype.validateSchema = function(p, d, S, A) {
    var a = new n(p, d, S, A);
    if (typeof d == "boolean") d === !0 ? d = {} : d === !1 && (d = { type: [] });
    else if (!d) throw new Error("schema is undefined");
    if (d.extends) if (Array.isArray(d.extends)) {
      var _ = { schema: d, ctx: A };
      d.extends.forEach(this.schemaTraverser.bind(this, _)), d = _.schema, _.schema = null, _.ctx = null, _ = null;
    } else d = t.deepMerge(d, this.superResolve(d.extends, A));
    var v = C(d);
    if (v) {
      var l = this.resolve(d, v, A), m = new T(l.subschema, S, A.path, l.switchSchema, A.schemas);
      return this.validateSchema(p, l.subschema, S, m);
    }
    var D = S && S.skipAttributes || [];
    for (var i in d) if (!e.ignoreProperties[i] && D.indexOf(i) < 0) {
      var r = null, E = this.attributes[i];
      if (E) r = E.call(this, p, d, S, A);
      else if (S.allowUnknownAttributes === !1) throw new P("Unsupported attribute: " + i, d);
      r && a.importErrors(r);
    }
    if (typeof S.rewrite == "function") {
      var h = S.rewrite.call(this, p, d, S, A);
      a.instance = h;
    }
    return a;
  }, y.prototype.schemaTraverser = function(p, d) {
    p.schema = t.deepMerge(p.schema, this.superResolve(d, p.ctx));
  }, y.prototype.superResolve = function(p, d) {
    var S = C(p);
    return S ? this.resolve(p, S, d).subschema : p;
  }, y.prototype.resolve = function(p, d, S) {
    if (d = S.resolve(d), S.schemas[d]) return { subschema: S.schemas[d], switchSchema: d };
    let A = new URL(d, "thismessage::/").hash;
    var a = A && A.length && d.substr(0, d.length - A.length);
    if (!a || !S.schemas[a]) throw new P("no such schema <" + d + ">", p);
    var _ = t.objectGetPath(S.schemas[a], A.substr(1));
    if (_ === void 0) throw new P("no such schema " + A + " located in <" + a + ">", p);
    return { subschema: _, switchSchema: d };
  }, y.prototype.testType = function(p, d, S, A, a) {
    if (a !== void 0) {
      if (a === null) throw new P('Unexpected null in "type" keyword');
      if (typeof this.types[a] == "function") return this.types[a].call(this, p);
      if (a && typeof a == "object") {
        var _ = this.validateSchema(p, a, S, A);
        return _ === void 0 || !(_ && _.errors.length);
      }
      return !0;
    }
  };
  var U = y.prototype.types = {};
  return U.string = function(p) {
    return typeof p == "string";
  }, U.number = function(p) {
    return typeof p == "number" && isFinite(p);
  }, U.integer = function(p) {
    return typeof p == "number" && p % 1 == 0;
  }, U.boolean = function(p) {
    return typeof p == "boolean";
  }, U.array = function(p) {
    return Array.isArray(p);
  }, U.null = function(p) {
    return p === null;
  }, U.date = function(p) {
    return p instanceof Date;
  }, U.any = function(p) {
    return !0;
  }, U.object = function(p) {
    return p && typeof p == "object" && !Array.isArray(p) && !(p instanceof Date);
  }, Qe = y;
}
var ke = (function() {
  if (tt) return oe;
  tt = 1;
  var e = oe.Validator = Rt();
  return oe.ValidatorResult = Te().ValidatorResult, oe.ValidatorResultError = Te().ValidatorResultError, oe.ValidationError = Te().ValidationError, oe.SchemaError = Te().SchemaError, oe.SchemaScanResult = qe().SchemaScanResult, oe.scan = qe().scan, oe.validate = function(t, s, n) {
    return new e().validate(t, s, n);
  }, oe;
})();
const J = (e, t) => {
  if (!t) return console.error({ name: "ValidationError", message: `unable to send request for ${e.id}: body missing` }), !1;
  try {
    if (!e.properties) return console.error({ name: "ValidationError", message: "Schema does not have any properties to validate", schema: e }), !1;
    const n = Object.entries(e.properties), c = Object.keys(t);
    if (n.length < c.length) return console.error({ name: "ValidationError", message: `unable to send request for ${e.id}: body has more properties (${c.length}) than schema (${n.length})` }), !1;
  } catch (n) {
    return console.error({ name: "ValidationError", message: `unable to send request for ${e.id}: unexpected error`, data: n }), !1;
  }
  const s = ke.validate(t, e, { required: !0 });
  return s.valid || console.error({ name: "ValidationError", message: `unable to send request for ${e.id}: invalid body`, data: s.errors }), s.valid;
}, H = (e, t) => {
  const s = ke.validate(t, e);
  return s.valid || console.error({ name: "ValidationError", message: `unable to send request for ${e.id}: invalid params`, data: s.errors }), s.valid;
}, ne = (e, t) => {
  const s = ke.validate(t, e);
  return s.valid || console.error({ name: "ValidationError", message: `unable to send request for ${e.id}: invalid query`, data: s.errors }), s.valid;
}, Ye = (e) => {
  if (!e) return "";
  const t = {};
  for (const [s, n] of Object.entries(e)) n && (t[s] = n.toString());
  return Object.keys(t).length ? `?${new URLSearchParams(t).toString()}` : "";
};
var Ut = ((e) => (e.IndexSizeError = "IndexSizeError", e.HierarchyRequestError = "HierarchyRequestError", e.WrongDocumentError = "WrongDocumentError", e.InvalidCharacterError = "InvalidCharacterError", e.NoModificationAllowedError = "NoModificationAllowedError", e.NotFoundError = "NotFoundError", e.NotSupportedError = "NotSupportedError", e.InvalidStateError = "InvalidStateError", e.InUseAttributeError = "InUseAttributeError", e.SyntaxError = "SyntaxError", e.InvalidModificationError = "InvalidModificationError", e.NamespaceError = "NamespaceError", e.InvalidAccessError = "InvalidAccessError", e.SecurityError = "SecurityError", e.NetworkError = "NetworkError", e.AbortError = "AbortError", e.URLMismatchError = "URLMismatchError", e.QuotaExceededError = "QuotaExceededError", e.TimeoutError = "TimeoutError", e.InvalidNodeTypeError = "InvalidNodeTypeError", e.DataCloneError = "DataCloneError", e.EncodingError = "EncodingError", e.NotReadableError = "NotReadableError", e.UnknownError = "UnknownError", e.ConstraintError = "ConstraintError", e.DataError = "DataError", e.TransactionInactiveError = "TransactionInactiveError", e.ReadOnlyError = "ReadOnlyError", e.VersionError = "VersionError", e.OperationError = "OperationError", e.NotAllowedError = "NotAllowedError", e))(Ut || {});
const Nt = (e, t) => e instanceof DOMException && (e.name === "AbortError" ? (console.warn(t && t.reason ? t.reason : e), !0) : (console.debug("unhandled DOM exception"), console.error(e), !1)), Lt = (e) => b((t) => {
  e({ type: "SET_USER_FEATURES", data: t });
}, [e]), rt = { type: "SET_USER_FEATURES", action: (e, t) => ({ ...e, features: t }) }, Ot = (e) => b((t) => {
  e({ type: "SET_USER_TENANCY", data: t });
}, [e]), at = { type: "SET_USER_TENANCY", action: (e, t) => ({ ...e, tenant: t }) }, Ct = (e) => b((t) => {
  e({ type: "SET_USER_TENANCY_SLUG", data: t });
}, [e]), it = { type: "SET_USER_TENANCY_SLUG", action: (e, t) => ({ ...e, slug: t }) }, gt = (e) => b((t) => {
  e({ type: "SET_USER_TOKEN", data: t });
}, [e]), st = { type: "SET_USER_TOKEN", action: (e, t) => ({ ...e, Token: t }) }, Dt = (e) => b((t) => {
  e({ type: "SET_USER", data: t });
}, [e]), nt = { type: "SET_USER", action: (e, t) => ({ ...e, ...t }) }, Ht = (e, t) => {
  switch (t.type) {
    case nt.type:
      return nt.action(e, t.data);
    case rt.type:
      return rt.action(e, t.data);
    case at.type:
      return at.action(e, t.data);
    case it.type:
      return it.action(e, t.data);
    case st.type:
      return st.action(e, t.data);
  }
}, ht = { tenant: "", slug: "", token: "", isLoggedIn: !1 }, Ue = () => {
  console.warn("unable to use state USER: state not setup");
}, Vt = { ...ht, setUser: Ue, setUserTenant: Ue, setUserTenantSlug: Ue, setUserToken: Ue, setUserFeatures: Ue }, ut = _t(Vt), bt = () => vt(ut), dn = ({ children: e }) => {
  const [t, s] = Tt(Ht, { ...ht }), n = { ...t, setUser: Dt(s), setUserTenant: Ot(s), setUserTenantSlug: Ct(s), setUserToken: gt(s), setUserFeatures: Lt(s) };
  return Me.jsx(ut.Provider, { value: n, children: e });
}, Le = () => {
  const { token: e, slug: t } = bt();
  return b(({ url: s, method: n, headers: c, body: P, signal: T, camel: y = !0, authRequired: C, tenantRequired: U }) => {
    if (C && (!e || U && !t)) {
      const d = { type: "process-error", status_code: -1, error_code: "ServiceNotReady", message: "unable to fetch data: token or tenant is not set" };
      return Promise.reject({ isError: !0, data: d });
    }
    const p = c ? { ...c } : {};
    return p.Accept || (p.Accept = "application/json"), p["Content-Type"] || (p["Content-Type"] = "application/json"), p["Content-Type"] === "multipart/form-data" && delete p["Content-Type"], p.Authorization = `Bearer ${e}`, p["x-curate-tenant-slug"] = t, p["x-request-id"] = window.crypto.randomUUID(), new Promise((d, S) => {
      const A = (a, _) => {
        const v = Nt(a, T), l = !_ || Mt(_?.status, a);
        if (v || l || console.error(a), a.status_code) {
          const m = { isError: !0, data: { ...a, type: "http-error" } };
          S(m);
        } else
          S({ isError: !0, data: a });
      };
      fetch(s, { method: n, headers: p, body: P === void 0 ? null : p["Content-Type"] === "application/json" ? JSON.stringify(lt(P)) : P }).then((a) => {
        const _ = /* @__PURE__ */ ((r) => (E) => {
          A(E, r);
        })(a);
        if (!a.ok) return void _({ status: a.status, statusText: a.statusText });
        const v = a.headers.get("Content-Type");
        if (!v)
          return void S({ isError: !0, data: { type: "process-error", status_code: -1, error_code: "UnknownContentType", message: "unable to export planogram: missing content type from response", response: a } });
        const l = v.split(";")[0], m = (r) => {
          d({ isError: !1, data: y ? Pt(r) : r });
        }, D = (r) => {
          d({ isError: !1, data: r });
        }, i = (r) => {
          d({ isError: !1, data: r });
        };
        switch (l) {
          case "text/csv":
          case "text/plain":
            a.text().then(D, S).catch(_);
            break;
          case "application/json":
            a.json().then(m, S).catch(_);
            break;
          case "application/zip":
            a.blob().then(i, S).catch(_);
            break;
          default:
            S({ isError: !0, data: { type: "process-error", status_code: -1, error_code: "UnknownMediaType", message: `unable to export document assortment: media type ${l} is not supported`, response: a } });
            break;
        }
      }, A).catch(A);
    });
  }, [e, t]);
};
var L = ((e) => (e.GET = "GET", e.POST = "POST", e.PUT = "PUT", e.PATCH = "PATCH", e.DELETE = "DELETE", e))(L || {});
const En = ({ getEndpoint: e, preflightValidation: t, chunkSize: s = 6, onUpdate: n }) => {
  const c = Le(), P = re(!1), [T, y] = G(!1), [C, U] = G(!1), [p, d] = G(), [S, A] = G(), a = re([]), _ = re([]), [v, l] = G([]), [m, D] = G(0), i = b((E) => {
    if (!E.length) return void console.warn("batch has nothing to process", v, E);
    const h = [];
    let o = !1, f = "", u = "";
    _.current = [];
    for (let I = 0, N = E.length; I < N; I++) {
      if (o = !t || t(E[I]), !o) {
        console.warn("batch request error: failed to pass preflightValidation", E[I]);
        break;
      }
      if (f = e(E[I]), !f) {
        o = !1, console.warn("batch request error: failed to create url", E[I]);
        break;
      }
      const g = new AbortController();
      _.current.push(g), u = Ye(E[I].query || {}), h.push({ ...E[I], url: u ? `${f}${u}` : f, method: L.GET, signal: g.signal });
    }
    h.length ? o ? (a.current = h.map((I) => c(I)), y(!0)) : console.warn("batch has invalid request") : console.debug("batch process does not have requests to send");
  }, [v, c, e, t]), r = b((E) => {
    E.length ? (U(!1), d(void 0), l(E), D(0)) : console.warn("batch request requires an list of params and/or queries");
  }, []);
  return Q(() => {
    if (!v || !v.length) return;
    const E = m, h = m + s, o = v.slice(E, h);
    o.length ? i(o) : console.warn("next batch empty", E, h, v);
  }, [v, m, s, i]), Q(() => {
    T && a.current.length && Promise.allSettled(a.current).then((E) => {
      const h = [], o = [];
      E.forEach((u) => {
        u.status !== "rejected" ? u.value.isError ? h.push(u.value) : o.push(u.value.data) : h.push(u.reason);
      }), h.length && (A(h), console.warn(h)), d((u) => u ? (n && n(o.slice(), u.slice()), u.concat(o)) : (n && n(o.slice(), []), o));
      const f = m + s;
      f < v.length ? D(f) : (U(!0), y(!1));
    }).catch((E) => {
      A([E]), U(!0), y(!1);
    });
  }, [v.length, m, s, T, n]), Q(() => (P.current = !0, () => {
    P.current = !1, _.current && _.current.length && _.current.forEach((E) => {
      E.abort();
    });
  }), []), [T, C, p, r, S];
}, Gt = ({ maxConcurrency: e = 8, getEndpoint: t, preflightValidation: s, method: n, headers: c, onFinish: P, onError: T, onResponse: y, onEmptyQueue: C }) => {
  const U = Le(), p = re(!1), d = re(/* @__PURE__ */ new Map()), S = re(null), [A, a] = G(!1), [_, v] = G(0), l = b((r) => {
    T && T(r);
  }, [T]), m = b(() => {
    v((r) => r + 1);
  }, []), D = b(() => {
    if (d.current.size < e && S.current !== null) {
      const o = performance.now().toFixed(0).toString();
      d.current.set(o, { args: S.current.args }), S.current.resolve(!0), S.current = null;
    }
    if (!d.current.size && !S.current) return m(), void a(!1);
    const r = Array.from(d.current.keys());
    let E = 0;
    const h = [];
    for (a(!0); E < r.length && d.current.size > 0; ) {
      const o = r[E], f = d.current.get(o);
      if (E++, !f) {
        d.current.delete(o);
        continue;
      }
      if (f.abortController) continue;
      if (!(!s || s(f.args))) {
        l({ name: "InvalidPreFlightValidation", details: f.args }), d.current.delete(o);
        continue;
      }
      const u = t(f.args);
      if (!u) {
        l({ name: "InvalidUrl", details: f.args }), d.current.delete(o);
        continue;
      }
      const I = new AbortController(), N = U({ url: u, method: n, headers: c, signal: I.signal, body: f.args.body });
      h.push(N), d.current.set(o, { args: f.args, abortController: I }), N.finally(() => {
        P && P({ params: f.args.params }), d.current.delete(o);
      });
    }
    Promise.race(h).then((o) => {
      y && y(o), D();
    }, l);
  }, [e, l, m, s, t, U, n, c, P, y]), i = b((r) => new Promise((E) => {
    if (d.current.size < e) {
      const h = performance.now().toFixed(0).toString();
      return d.current.set(h, { args: r }), D(), void E(!0);
    }
    S.current = { resolve: E, args: r };
  }), [e, D]);
  return Q(() => {
    _ && C && (C(_), v(0));
  }, [C, _]), Q(() => (p.current = !0, () => {
    p.current = !1, d.current && d.current.size && (d.current.forEach((r) => {
      r.abortController && r.abortController.abort();
    }), d.current = /* @__PURE__ */ new Map());
  }), []), [A, i];
}, Yt = (e, t, s, n) => {
  const c = e - t, P = Math.ceil(c / s);
  return P ? P - n > -1 ? n : P : -1;
}, Ft = ({ getEndpoint: e, pageLimit: t, chunkLimit: s, requestDelay: n, onUpdate: c, onComplete: P, onFailure: T }) => {
  const y = Le(), C = re(!1), U = re(), [p, d] = G(), [S, A] = G(!1), [a, _] = G(), [v, l] = G([]), m = b(() => {
    U.current && U.current.abort(), p && clearTimeout(p);
  }, [p]), D = b((i, r, E = !0) => {
    E && m();
    const h = (({ response: u, direction: I = "next" }) => {
      if (!Object.hasOwn(u, I) || u[I] === void 0 || u[I] === null) return console.warn(`unable to get offset value: response has no ${I} url`, u), -1;
      const N = u[I];
      if (N == null || typeof N != "string") return console.warn(`unable to get offset value: response has no ${I} url`, u), -1;
      const g = new URL(N).searchParams.get("offset");
      if (!g) return console.warn("unable to get offset value: offset param missing from response next url", u), -1;
      const K = parseInt(g);
      return isNaN(K) ? (console.warn("unable to get offset value: offset param is not a number", u, g), -1) : K;
    })({ response: i });
    if (A(!0), h === -1) {
      if (i.count !== i.results.length) return void console.warn("unable to send request chunks: no offset", i, h);
      const u = [...v, ...i.results];
      return l(u), c && c(i.results, u), P && P(), void A(!1);
    }
    const o = Yt(i.count, h, t, s);
    if (o === -1) return console.warn("unable to get next chunk: no chunks left", i, o), void A(!1);
    const f = setTimeout(() => {
      const u = [];
      U.current = new AbortController(), _(void 0);
      for (let I = 0; I < o; I++) {
        const N = e(r);
        if (!N) {
          const q = { isError: !0, data: { type: "process-error", status_code: -1, error_code: "MalformedURL", message: "unable to DRAIN: url is missing" } };
          console.warn(q, r), _(q), A(!1);
          break;
        }
        let g = "";
        Object.hasOwn(r, "query") && (g = Ye({ ...r.query, offset: I * t + h, limit: t }));
        const K = { ...r, url: `${N}${g}`, method: L.GET, signal: U.current.signal };
        u.push(y(K));
      }
      Promise.allSettled(u).then((I) => {
        if (!C.current) return;
        const N = [], g = [];
        let K;
        if (I.forEach((x) => {
          x.status === "rejected" ? N.push(x.reason) : x.status === "fulfilled" && (x.value.isError ? N.push(x.value) : (g.push(...x.value.data.results), K = x.value.data));
        }), !K) {
          const x = { isError: !0, data: { type: "process-error", status_code: -1, error_code: "NoLastChunk", message: "unable to get next chunk: chunks malformed" } };
          return N.push(x), _(N), void (T && T(N));
        }
        N.length && T && T(N);
        const q = [...v, ...g];
        l(q), c && c(g, q), K.next ? D(K, r) : (P && P(), A(!1));
      });
    }, n);
    d(f);
  }, [m, v, s, y, e, P, T, c, t, n]);
  return Q(() => (C.current = !0, () => {
    C.current = !1, U.current?.abort();
  }), []), [S, v, D, a, m];
}, _n = ({ getEndpoint: e, preflightValidation: t, pageLimit: s = 100, chunkLimit: n = 2, requestDelay: c = 500, onUpdate: P, onComplete: T, onFailure: y }, C) => {
  const U = Le(), p = re(!1), d = re(), [S, A] = G(!1), [a, _] = G(!1), v = re([]), [l, m] = G(), [D, i] = G(), [r, E] = G(0), h = b((j) => {
    p.current && (v.current.push(...j), P && P(j, v.current), m([...v.current]));
  }, [P]), o = b((j) => {
    if (p.current) return Array.isArray(j) || j.isError ? (y && y(j), console.debug(j), i(j), _(!0), void A(!1)) : void (j.isError || (console.error("DRAIN request handling non-error in Error handler", j), _(!0), A(!1)));
  }, [y]), f = b(() => {
    T && T(), _(!0), A(!1);
  }, [T]), [u, I, N, g, K] = Ft({ getEndpoint: e, pageLimit: s, chunkLimit: n, requestDelay: c, onUpdate: h, onComplete: f, onFailure: o }), q = b(() => {
    d.current && d.current.abort(), K();
  }, [K]), x = b((j) => (B) => {
    if (p.current) if (B.isError) o(B);
    else {
      if (v.current = [...B.data.results], E(B.data.count), m(v.current), !B.data.next) return _(!0), void A(!1);
      N(B.data, j);
    }
  }, [N, o]), ve = b((j, B = !0) => {
    if (B && q(), A(!0), _(!1), E(0), v.current = [], !(!t || t(j)))
      return void o({ isError: !0, data: { type: "process-error", status_code: -1, error_code: "PreflightValidation", message: "GET request did not pass preflight validation" } });
    const ie = e(j);
    if (!ie)
      return void o({ isError: !0, data: { type: "process-error", status_code: -1, error_code: "MalformedURL", message: "unable to DRAIN: url is missing" } });
    const he = Ye(j.query), Se = x(j);
    d.current = new AbortController();
    const Ie = { ...j, url: he ? `${ie}${he}` : ie, method: L.GET, signal: d.current.signal };
    i(void 0), U(Ie).then(Se, o).catch(o);
  }, [q, U, e, o, x, t]);
  return Q(() => {
    p.current = !0;
    const j = d.current?.abort;
    return () => {
      p.current = !1, j && j();
    };
  }, []), Q(() => {
    !C || S || l || D || g || ve(C);
  }, [g, l, ve, D, C, S]), [S || u, a, l, r, ve, D || g];
}, O = ({ getEndpoint: e, preflightValidation: t, formatQuery: s, onSuccess: n, onFailure: c, method: P, authRequired: T = !0, tenantRequired: y = !0, headers: C }, U) => {
  const p = Le(), d = re(!1), S = re(), [A, a] = G(!1), [_, v] = G(), [l, m] = G(), D = b((E) => {
    if (d.current) {
      if (E.isError) return c && c(E), m(E), void a(!1);
      if (n) {
        const h = n(E.data);
        v(h || E.data);
      } else v(E.data);
      a(!1);
    }
  }, [c, n]), i = b((E) => {
    console.debug(E), d.current && (E.isError && (m(E), c && c(E)), a(!1));
  }, [c]);
  b((E) => {
    S.current?.abort(E);
  }, []);
  const r = b((E, h = !0) => {
    const o = e(E);
    if (!o)
      return void console.warn({ error_code: "MalformedURL", message: "unable to send GET request: url is missing" }, E);
    const { params: f, query: u, body: I, ...N } = E;
    let g;
    if (typeof E.params != "boolean") {
      if (!(!t || t({ params: f, query: u, body: I })))
        return void console.warn({ error_code: "PreflightValidation", message: "GET request did not pass preflight validation" }, E);
      const q = u ? s ? s(u) : u : void 0;
      g = { ...N, url: q ? `${o}${Ye(q)}` : o, method: P, body: I, authRequired: T, tenantRequired: y, headers: C };
    } else g = { url: o, method: P, authRequired: T, tenantRequired: y, headers: C };
    h && S.current?.abort();
    const K = new AbortController();
    g.signal = K.signal, v(void 0), m(void 0), S.current = K, a(!0), p(g).then(D, i).catch(i);
  }, [e, p, D, i, t, s, P, T, y, C]);
  return Q(() => {
    d.current = !0;
    const E = S.current?.abort;
    return () => {
      d.current = !1, E && E();
    };
  }, []), Q(() => {
    !U || A || _ || l || (typeof U.params != "boolean" || U.params) && r(U);
  }, [_, l, r, U, A]), ae(() => [A, _, r, l], [A, _, r, l]);
}, Mt = (e, t) => e >= 200 && e <= 209 || e >= 300 && e <= 308 || (e >= 400 && e <= 429 ? (console.warn(t), !0) : e >= 500 && e <= 511 ? (console.error(t), !0) : (console.debug("unhandled HTTP Status"), console.error(t), !1)), qt = ({ params: e }) => `https://dev.hivery.ai/api/v1/agent/assistants${e?.assistantId ? `/${e?.assistantId}` : ""}`, jt = { id: "ParamsGetAgentAssistants", type: "object", properties: { assistantId: { type: "string", required: !0 } }, required: !1 }, wt = ({ params: e }) => H(jt, e), vn = (e, t) => O({ ...t, method: L.GET, getEndpoint: qt, preflightValidation: wt }, e), kt = ({ params: e }) => {
  const t = { ENV: "dev", HIVEMIND_ENV: "dev.hivery.ai", CY_TEST: "true", JEST: !1, ALLOW_PASSWORD_LOGIN: "true", CURATE_API_V1: "https://dev.hivery.ai/api/v1/curate", CURATE_API_V2: "https://dev.hivery.ai/api/v2/curate", INTERACTIVE_EDIT_API: "https://dev.hivery.ai/api/v1/ie", PREDICTION_API: "https://dev.hivery.ai/api/v1/prediction", SSDI_API: "https://dev.hivery.ai/api/v1/ssdi", SSDI_API_V2: "https://dev.hivery.ai/api/v2/ssdi", STRATEGY_API: "https://dev.hivery.ai/api/v1/strategies", AGENT_API: "https://dev.hivery.ai/api/v1/agent", FILES_API_HOST: "", AUTH0_CLIENT_ID: "pkcXkULYXQfYaFHpeb6BVPRoP0V1XIJN", AUTH0_DOMAIN: "auth.dev.hivery.ai", AUTH0_AUDIENCE: "propel-api-dev", PUSHER_APP_KEY: "1a2f9c6611892edf8b3f", PUSHER_CLUSTER: "us3", PUSHER_IE_APP_KEY: "1a2f9c6611892edf8b3f", PUSHER_IE_CLUSTER: "us3", UNLEASH_URL: "https://zero.hivery.ai/unleash/api/frontend", UNLEASH_TOKEN: "*:development.73b148c1e2fe6b2e0aeedfe610ee2d6e8c5890dea9f00e6a08c8638d", UNLEASH_ENV: "development", OTEL_KEY: "", OTEL_COLLECTOR_URL: "https://dev.hivery.ai/collect", OTEL_SERVICE_NAME: "", PRODUCT_IMAGE_HOST: "dev", AZURE_CDN_DOMAIN: "https://app.dev.hivery.ai" };
  if (e?.threadId && e?.messageId) return `${t.AGENT_API}/threads/${e.threadId}/messages/${e.messageId}`;
}, Kt = { id: "ParamsGetAgentMessage", type: "object", properties: { threadId: { type: "string", required: !0 }, messageId: { type: "string", required: !0 } }, required: !1 }, $t = ({ params: e }) => H(Kt, e), hn = (e, t) => O({ ...t, method: L.GET, getEndpoint: kt, preflightValidation: $t }, e), xt = ({ params: e }) => {
  const t = { ENV: "dev", HIVEMIND_ENV: "dev.hivery.ai", CY_TEST: "true", JEST: !1, ALLOW_PASSWORD_LOGIN: "true", CURATE_API_V1: "https://dev.hivery.ai/api/v1/curate", CURATE_API_V2: "https://dev.hivery.ai/api/v2/curate", INTERACTIVE_EDIT_API: "https://dev.hivery.ai/api/v1/ie", PREDICTION_API: "https://dev.hivery.ai/api/v1/prediction", SSDI_API: "https://dev.hivery.ai/api/v1/ssdi", SSDI_API_V2: "https://dev.hivery.ai/api/v2/ssdi", STRATEGY_API: "https://dev.hivery.ai/api/v1/strategies", AGENT_API: "https://dev.hivery.ai/api/v1/agent", FILES_API_HOST: "", AUTH0_CLIENT_ID: "pkcXkULYXQfYaFHpeb6BVPRoP0V1XIJN", AUTH0_DOMAIN: "auth.dev.hivery.ai", AUTH0_AUDIENCE: "propel-api-dev", PUSHER_APP_KEY: "1a2f9c6611892edf8b3f", PUSHER_CLUSTER: "us3", PUSHER_IE_APP_KEY: "1a2f9c6611892edf8b3f", PUSHER_IE_CLUSTER: "us3", UNLEASH_URL: "https://zero.hivery.ai/unleash/api/frontend", UNLEASH_TOKEN: "*:development.73b148c1e2fe6b2e0aeedfe610ee2d6e8c5890dea9f00e6a08c8638d", UNLEASH_ENV: "development", OTEL_KEY: "", OTEL_COLLECTOR_URL: "https://dev.hivery.ai/collect", OTEL_SERVICE_NAME: "", PRODUCT_IMAGE_HOST: "dev", AZURE_CDN_DOMAIN: "https://app.dev.hivery.ai" };
  if (e?.threadId && e?.runId) return `${t.AGENT_API}/threads/${e.threadId}/runs/${e.runId}`;
}, Xt = { id: "ParamsGetAgentRun", type: "object", properties: { threadId: { type: "string", required: !0 }, runId: { type: "string", required: !0 } }, required: !1 }, zt = ({ params: e }) => H(Xt, e), un = (e, t) => O({ ...t, method: L.GET, getEndpoint: xt, preflightValidation: zt }, e), Zt = ({ params: e }) => `https://dev.hivery.ai/api/v1/agent/threads${e?.threadId ? `/${e?.threadId}` : ""}`, Bt = { id: "ParamsGetAgentThreads", type: "object", properties: { threadId: { type: "string", required: !0 } }, required: !1 }, Wt = ({ params: e }) => H(Bt, e), cn = (e, t) => O({ ...t, method: L.GET, getEndpoint: Zt, preflightValidation: Wt }, e), Jt = ({ params: e }) => {
  const t = { ENV: "dev", HIVEMIND_ENV: "dev.hivery.ai", CY_TEST: "true", JEST: !1, ALLOW_PASSWORD_LOGIN: "true", CURATE_API_V1: "https://dev.hivery.ai/api/v1/curate", CURATE_API_V2: "https://dev.hivery.ai/api/v2/curate", INTERACTIVE_EDIT_API: "https://dev.hivery.ai/api/v1/ie", PREDICTION_API: "https://dev.hivery.ai/api/v1/prediction", SSDI_API: "https://dev.hivery.ai/api/v1/ssdi", SSDI_API_V2: "https://dev.hivery.ai/api/v2/ssdi", STRATEGY_API: "https://dev.hivery.ai/api/v1/strategies", AGENT_API: "https://dev.hivery.ai/api/v1/agent", FILES_API_HOST: "", AUTH0_CLIENT_ID: "pkcXkULYXQfYaFHpeb6BVPRoP0V1XIJN", AUTH0_DOMAIN: "auth.dev.hivery.ai", AUTH0_AUDIENCE: "propel-api-dev", PUSHER_APP_KEY: "1a2f9c6611892edf8b3f", PUSHER_CLUSTER: "us3", PUSHER_IE_APP_KEY: "1a2f9c6611892edf8b3f", PUSHER_IE_CLUSTER: "us3", UNLEASH_URL: "https://zero.hivery.ai/unleash/api/frontend", UNLEASH_TOKEN: "*:development.73b148c1e2fe6b2e0aeedfe610ee2d6e8c5890dea9f00e6a08c8638d", UNLEASH_ENV: "development", OTEL_KEY: "", OTEL_COLLECTOR_URL: "https://dev.hivery.ai/collect", OTEL_SERVICE_NAME: "", PRODUCT_IMAGE_HOST: "dev", AZURE_CDN_DOMAIN: "https://app.dev.hivery.ai" };
  if (e?.threadId) return `${t.AGENT_API}/threads/${e.threadId}/messages`;
}, Qt = { id: "ParamsListAgentMessages", type: "object", properties: { threadId: { type: "string", required: !0 } }, required: !1 }, er = { id: "QueryListAgentMessages", type: "object", properties: { limit: { type: "number", required: !1, minimum: 1, maximum: 100 }, offset: { type: "number", required: !1, minimum: 1 } }, required: !1 }, tr = ({ params: e, query: t }) => {
  const s = H(Qt, e);
  return s && ne(er, t);
}, An = (e, t) => O({ ...t, method: L.GET, getEndpoint: Jt, preflightValidation: tr }, e), rr = { SINGLE: "single_agent_assistant" }, ar = { SCENARIO: "scenario" }, ir = { USER: "user", ASSISTANT: "assistant" }, In = { IN_PROGRESS: "in_progress", INCOMPLETE: "incomplete", COMPLETED: "completed" }, Tn = { DIALOGUE: "dialogue", MONOLOGUE: "monologue", CHART: "chart" }, Sn = { NOMINAL: "nominal" }, Pn = { BAR: "bar" }, ln = { SVG: "image/svg+xml", HTML: "image/html" }, fn = { QUEUED: "queued", IN_PROGRESS: "in_progress", FAILED: "failed", COMPLETED: "completed" }, sr = () => "https://dev.hivery.ai/api/v1/agent/assistants", nr = { id: "BodyPostAgentAssistant", type: "object", properties: { assistantConfig: { type: "object", required: !0, additionalProperties: !1, properties: { assistantType: { type: "string", required: !0, enum: [rr.SINGLE] } } }, description: { type: "string" } }, required: !0 }, or = ({ body: e }) => J(nr, e), yn = (e) => O({ ...e, method: L.POST, getEndpoint: sr, preflightValidation: or }), pr = ({ params: e }) => {
  const t = { ENV: "dev", HIVEMIND_ENV: "dev.hivery.ai", CY_TEST: "true", JEST: !1, ALLOW_PASSWORD_LOGIN: "true", CURATE_API_V1: "https://dev.hivery.ai/api/v1/curate", CURATE_API_V2: "https://dev.hivery.ai/api/v2/curate", INTERACTIVE_EDIT_API: "https://dev.hivery.ai/api/v1/ie", PREDICTION_API: "https://dev.hivery.ai/api/v1/prediction", SSDI_API: "https://dev.hivery.ai/api/v1/ssdi", SSDI_API_V2: "https://dev.hivery.ai/api/v2/ssdi", STRATEGY_API: "https://dev.hivery.ai/api/v1/strategies", AGENT_API: "https://dev.hivery.ai/api/v1/agent", FILES_API_HOST: "", AUTH0_CLIENT_ID: "pkcXkULYXQfYaFHpeb6BVPRoP0V1XIJN", AUTH0_DOMAIN: "auth.dev.hivery.ai", AUTH0_AUDIENCE: "propel-api-dev", PUSHER_APP_KEY: "1a2f9c6611892edf8b3f", PUSHER_CLUSTER: "us3", PUSHER_IE_APP_KEY: "1a2f9c6611892edf8b3f", PUSHER_IE_CLUSTER: "us3", UNLEASH_URL: "https://zero.hivery.ai/unleash/api/frontend", UNLEASH_TOKEN: "*:development.73b148c1e2fe6b2e0aeedfe610ee2d6e8c5890dea9f00e6a08c8638d", UNLEASH_ENV: "development", OTEL_KEY: "", OTEL_COLLECTOR_URL: "https://dev.hivery.ai/collect", OTEL_SERVICE_NAME: "", PRODUCT_IMAGE_HOST: "dev", AZURE_CDN_DOMAIN: "https://app.dev.hivery.ai" };
  if (e?.threadId) return `${t.AGENT_API}/threads/${e.threadId}/messages`;
}, dr = { id: "ParamsPostAgentMessage", type: "object", properties: { threadId: { type: "string", required: !0 } }, required: !1 }, Er = { id: "BodyPostAgentMessage", type: "object", properties: { content: { type: "string", required: !0 }, role: { type: "string", required: !0, enum: [ir.USER] } }, required: !0 }, _r = ({ params: e, body: t }) => {
  const s = H(dr, e);
  return s && J(Er, t);
}, mn = (e) => O({ ...e, method: L.POST, getEndpoint: pr, preflightValidation: _r }), vr = ({ params: e }) => {
  const t = { ENV: "dev", HIVEMIND_ENV: "dev.hivery.ai", CY_TEST: "true", JEST: !1, ALLOW_PASSWORD_LOGIN: "true", CURATE_API_V1: "https://dev.hivery.ai/api/v1/curate", CURATE_API_V2: "https://dev.hivery.ai/api/v2/curate", INTERACTIVE_EDIT_API: "https://dev.hivery.ai/api/v1/ie", PREDICTION_API: "https://dev.hivery.ai/api/v1/prediction", SSDI_API: "https://dev.hivery.ai/api/v1/ssdi", SSDI_API_V2: "https://dev.hivery.ai/api/v2/ssdi", STRATEGY_API: "https://dev.hivery.ai/api/v1/strategies", AGENT_API: "https://dev.hivery.ai/api/v1/agent", FILES_API_HOST: "", AUTH0_CLIENT_ID: "pkcXkULYXQfYaFHpeb6BVPRoP0V1XIJN", AUTH0_DOMAIN: "auth.dev.hivery.ai", AUTH0_AUDIENCE: "propel-api-dev", PUSHER_APP_KEY: "1a2f9c6611892edf8b3f", PUSHER_CLUSTER: "us3", PUSHER_IE_APP_KEY: "1a2f9c6611892edf8b3f", PUSHER_IE_CLUSTER: "us3", UNLEASH_URL: "https://zero.hivery.ai/unleash/api/frontend", UNLEASH_TOKEN: "*:development.73b148c1e2fe6b2e0aeedfe610ee2d6e8c5890dea9f00e6a08c8638d", UNLEASH_ENV: "development", OTEL_KEY: "", OTEL_COLLECTOR_URL: "https://dev.hivery.ai/collect", OTEL_SERVICE_NAME: "", PRODUCT_IMAGE_HOST: "dev", AZURE_CDN_DOMAIN: "https://app.dev.hivery.ai" };
  if (e?.threadId) return `${t.AGENT_API}/threads/${e.threadId}/runs`;
}, hr = { id: "ParamsPostAgentRun", type: "object", properties: { threadId: { type: "string", required: !0 } }, required: !1 }, ur = { id: "ParamsPostAgentRun", type: "object", properties: { assistantId: { type: "string", required: !1 }, asyncMode: { type: "boolean", required: !1 } }, required: !1 }, cr = ({ params: e, body: t }) => {
  const s = H(hr, e);
  return s && J(ur, t);
}, Rn = (e) => O({ ...e, method: L.POST, getEndpoint: vr, preflightValidation: cr }), Ar = () => "https://dev.hivery.ai/api/v1/agent/threads", Ir = { id: "BodyPostAgentThread", type: "object", properties: { scope: { type: "object", required: !0, additionalProperties: !1, properties: { scopeLevel: { type: "string", required: !0, enum: [ar.SCENARIO] }, tenantSlug: { type: "string", required: !0 }, projectId: { type: "number", required: !0 }, scenarioId: { type: "number", required: !0 } } } }, required: !0 }, Tr = ({ body: e }) => J(Ir, e), Un = (e) => O({ ...e, method: L.POST, getEndpoint: Ar, preflightValidation: Tr }), Sr = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v1/ie/documents/${e.documentId}/assortment`;
}, Pr = { id: "ParamsGetAssortment", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, lr = ({ params: e }) => H(Pr, e), Nn = (e, t) => O({ ...t, method: L.GET, getEndpoint: Sr, preflightValidation: lr }, e), fr = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v1/ie/documents/${e.documentId}/pods`;
}, yr = { id: "ParamsGetPODS", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, mr = ({ params: e, query: t }) => {
  const s = H(yr, e);
  if (!s) return s;
  const n = ["product_id", "store_id"];
  return t ? t.fields = t.fields ? [...n, ...t.fields] : n : t = { fields: n }, !0;
}, Ln = (e, t) => O({ ...t, method: L.GET, getEndpoint: fr, preflightValidation: mr }, e), Rr = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v1/ie/tasks/${e.taskId}/status`;
}, Ur = { id: "ParamsGetTasksStatus", type: "object", properties: { taskId: { type: "integer", required: !0 } }, required: !0 }, Nr = ({ params: e }) => H(Ur, e), Lr = (e, t) => O({ ...t, method: L.GET, getEndpoint: Rr, preflightValidation: Nr }, e);
var fe = ((e) => (e.COMPLETED = "COMPLETED", e.PENDING = "PENDING", e.CANCELLED = "CANCELLED", e.STARTED = "STARTED", e.ERROR = "ERROR", e))(fe || {});
const ct = () => {
  const e = re(), [t, s] = G(!1), [n, c] = G(), [P, T] = G(), [y, C] = G(!1), U = b((_) => {
    if (!n || !n.params)
      return T({ isError: !0, data: { type: "process-error", error_code: "ValidationError", status_code: -1, message: "unable to continue polling task status: request params missing", response: _ } }), s(!1), _;
    switch (_.status) {
      case fe.ERROR:
      case fe.CANCELLED: {
        const v = { isError: !0, data: { type: "process-error", error_code: "ServerError", status_code: -1, message: `unable to continue polling task status: task resulted in ${_.status}: ${n.params.taskId}`, response: _ } };
        T(v), s(!1);
        break;
      }
      case fe.COMPLETED:
        s(!1);
        break;
      case fe.PENDING:
      case fe.STARTED:
        C(!0);
    }
    return _;
  }, [n]), p = b((_) => {
    T(_), s(!1);
  }, []), [d, S, A] = Lr(void 0, { onSuccess: U, onFailure: p }), a = b((_) => {
    s(!0), c(_), A(_);
  }, [A]);
  return Q(() => {
    y && n && (C(!1), e.current = setTimeout(() => {
      A(n);
    }, 5e3));
  }, [A, y, n]), Q(() => {
    const _ = e.current;
    return () => {
      _ && clearTimeout(_);
    };
  }, []), [t, S, a, P];
}, Or = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v1/ie/documents/${e.documentId}/stores/export_assortment`;
}, Cr = { id: "ParamsExportAssortment", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, gr = ({ params: e }) => H(Cr, e), On = () => {
  const [e, t] = G(!1), [s, n] = G(), [c, P] = G(), [T, y, C, U] = ct(), p = b((v) => {
    if (typeof v == "string") n(v), t(!1);
    else if (v instanceof Object && Object.hasOwn(v, "taskId")) C({ params: { taskId: v.taskId } });
    else {
      const l = { isError: !0, data: { type: "process-error", error_code: "UnknownResponse", status_code: -1, message: "unknown response type from posting assortment request", response: v } };
      P(l), console.warn(l);
    }
    return v;
  }, [C]), d = b((v) => {
    P(v), t(!1);
  }, []), [S, A, a] = O({ method: L.POST, getEndpoint: Or, preflightValidation: gr, onSuccess: p, onFailure: d }), _ = b((v) => {
    t(!0), a({ ...v, body: void 0 });
  }, [a]);
  return Q(() => {
    T || (U ? console.warn(U) : (n(y), t(!1)));
  }, [T, y, U]), ae(() => [e, s, _, c], [c, s, e, _]);
};
var Dr = ((e) => (e.ADDED = "added", e.REMOVED = "removed", e.RETAINED = "retained", e.EXCLUDED = "excluded", e))(Dr || {});
const Hr = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v1/ie/documents/${e.documentId}`;
}, Vr = { id: "ParamsGetDocuments", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, br = ({ params: e }) => H(Vr, e), Cn = (e, t) => O({ ...t, method: L.GET, getEndpoint: Hr, preflightValidation: br }, e), Gr = ({ params: e, query: t }) => {
  if (e)
    return `https://dev.hivery.ai/api/v1/ie/workspaces/${e.workspaceId}/documents/summaries`;
}, Yr = { id: "ParamsGetDocumentsSummaries", type: "object", properties: { workspaceId: { type: "integer", required: !0 } }, required: !0 }, Fr = ({ params: e, query: t }) => H(Yr, e), gn = (e, t) => O({ ...t, method: L.GET, getEndpoint: Gr, preflightValidation: Fr }, e);
var Mr = ((e) => (e.READY = "READY", e.BUSY = "BUSY", e))(Mr || {});
const qr = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v1/ie/documents/${e.documentId}/edit_requests/most_recent`;
}, jr = { id: "ParamsGetEditRequestsMostRecent", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, wr = ({ params: e }) => H(jr, e), kr = (e, t) => O({ ...t, method: L.GET, getEndpoint: qr, preflightValidation: wr }, e);
var je = ((e) => (e.pending = "PENDING", e.error = "ERROR", e.completed = "COMPLETED", e))(je || {}), _e = ((e) => (e.drop = "DROP_POSITION", e.dropProduct = "DROP_PRODUCT", e.insert = "INSERT_POSITION", e.insertProduct = "INSERT_PRODUCT", e.move = "MOVE_POSITION", e.setFacings = "SET_POSITION_FACINGS", e.setProduct = "SET_POSITION_PRODUCT", e.swap = "SWAP_POSITION", e.swapProduct = "SWAP_PRODUCT", e.insertProductBulk = "INSERT_POSITION_BULK", e.dropPositionBulk = "DROP_POSITION_BULK", e))(_e || {});
const Kr = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v1/ie/documents/${e.documentId}/edit_requests`;
}, $r = { id: "ParamsPostEditRequestsCreate", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, xr = ({ params: e }) => H($r, e), Ae = () => {
  const [e, t] = G(!1), [s, n] = G(), [c, P] = G(), T = b((m) => {
    n(m), t(!1);
  }, []), y = b((m) => (t(!1), m), []), [C, U, p, d] = O({ method: L.POST, getEndpoint: Kr, preflightValidation: xr, onFailure: T, onSuccess: y }), S = b((m) => {
    switch (m.status) {
      case je.completed:
        if (!c || !c.body) {
          n({ isError: !0, data: { type: "process-error", error_code: "ValidationError", status_code: -1, message: "unable to create edit request: edit request data is missing" } }), t(!1);
          break;
        }
        p({ ...c, body: { ...c.body, version: m.version + 1 } }), t(!1);
        break;
      case je.error:
        n({ isError: !0, data: { type: "process-error", error_code: "ServerError", status_code: -1, message: "unable to create edit request: most recent request encountered an error", response: m } }), t(!1);
        break;
    }
    return m;
  }, [p, c]), [A, a, _, v] = kr(void 0, { onFailure: T, onSuccess: S }), l = b((m) => {
    m.params ? (t(!0), n(void 0), P(m), _({ params: { documentId: m.params.documentId } })) : console.debug("unable to send edit request: params missing");
  }, [_]);
  return ae(() => [e, U, l, s], [U, s, e, l]);
}, Dn = () => {
  const [e, t, s, n] = Ae(), c = b(({ params: P, body: T }) => {
    if (!P || !T) return;
    const y = { version: 1, commandType: _e.drop, parameters: T };
    s({ params: P, body: { version: -1, commands: [y] } });
  }, [s]);
  return ae(() => [e, t, c, n], [e, c, t, n]);
}, Hn = () => {
  const [e, t, s, n] = Ae(), c = b(({ params: P, body: T }) => {
    if (!P || !T) return;
    const y = { version: 1, commandType: _e.dropProduct, parameters: T };
    s({ params: P, body: { version: -1, commands: [y] } });
  }, [s]);
  return ae(() => [e, t, c, n], [e, c, t, n]);
}, Vn = () => {
  const [e, t, s, n] = Ae(), c = b(({ params: P, body: T }) => {
    if (!P || !T) return;
    const y = { version: 1, commandType: _e.insert, parameters: T };
    s({ params: P, body: { version: -1, commands: [y] } });
  }, [s]);
  return ae(() => [e, t, c, n], [e, c, t, n]);
}, bn = () => {
  const [e, t, s, n] = Ae(), c = b(({ params: P, body: T }) => {
    if (!P || !T) return;
    const y = { version: 1, commandType: _e.insertProduct, parameters: T };
    s({ params: P, body: { version: -1, commands: [y] } });
  }, [s]);
  return ae(() => [e, t, c, n], [e, c, t, n]);
}, Gn = () => {
  const [e, t, s, n] = Ae(), c = b(({ params: P, body: T }) => {
    if (!P || !T) return;
    const y = { version: 1, commandType: _e.move, parameters: T };
    s({ params: P, body: { version: -1, commands: [y] } });
  }, [s]);
  return ae(() => [e, t, c, n], [e, c, t, n]);
}, Yn = () => {
  const [e, t, s, n] = Ae(), c = b(({ params: P, body: T }) => {
    if (!P || !T) return;
    const y = { version: 1, commandType: _e.setFacings, parameters: T };
    s({ params: P, body: { version: -1, commands: [y] } });
  }, [s]);
  return ae(() => [e, t, c, n], [e, c, t, n]);
}, Fn = () => {
  const [e, t, s, n] = Ae(), c = b(({ params: P, body: T }) => {
    if (!P || !T) return;
    const y = { version: 1, commandType: _e.swap, parameters: T };
    s({ params: P, body: { version: -1, commands: [y] } });
  }, [s]);
  return ae(() => [e, t, c, n], [e, c, t, n]);
}, Mn = () => {
  const [e, t, s, n] = Ae(), c = b(({ params: P, body: T }) => {
    if (!P || !T) return;
    const y = { version: 1, commandType: _e.swapProduct, parameters: T };
    s({ params: P, body: { version: -1, commands: [y] } });
  }, [s]);
  return ae(() => [e, t, c, n], [e, c, t, n]);
}, Xr = () => "https://dev.hivery.ai/api/v2/ssdi/test-auth", qn = (e, t) => O({ ...t, method: L.GET, getEndpoint: Xr }, e), At = { MOVEMENT: "movement", PRODUCT: "product", PRODUCT_INNOVATIONS: "product_innovations", LOCATION: "location", LOCATION_INNOVATIONS: "location_innovations", LOCATION_PLANOGRAMS: "location_planograms", AVAILABILITY: "availability", PLANOGRAMS: "planograms" }, jn = { PENDING: "pending", RESOLVING: "resolving", SUCCEEDED: "succeeded", FAILED: "failed", CANCELLED: "cancelled" }, zr = () => "https://dev.hivery.ai/api/v2/ssdi/files", Zr = { id: "BodyPostFilesUpload", type: "object", properties: { kind: { type: "string", required: !0, enum: Object.values(At) }, name: { type: "string", required: !0 } }, required: !0 }, Br = ({ body: e }) => J(Zr, e), Wr = (e) => O({ ...e, method: L.POST, getEndpoint: zr, preflightValidation: Br }), Jr = ({ params: e }) => {
  if (e) return `https://dev.hivery.ai/api/v2/ssdi/files/${e.id}/upload-complete`;
}, Qr = { id: "ParamsPostFilesUploadComplete", type: "object", properties: { id: { type: "string", required: !0 } }, required: !1 }, ea = { id: "BodyPostFilesUploadComplete", type: "object", properties: { filePartIds: { type: "array", required: !0, minItems: 1, items: { type: "string" }, additionalItems: !1 }, kind: { type: "string", required: !0, enum: Object.values(At) }, ext: { type: "string", required: !0 } }, required: !0 }, ta = ({ params: e, body: t }) => {
  const s = H(Qr, e);
  return s && J(ea, t);
}, ra = (e) => O({ ...e, method: L.POST, getEndpoint: Jr, preflightValidation: ta }), aa = ({ params: e }) => {
  if (e) return `https://dev.hivery.ai/api/v2/ssdi/files/${e.id}/upload-part/${e.part_number}`;
}, ia = { id: "ParamsPostFilesUploadPart", type: "object", properties: { id: { type: "string", required: !0 }, part_number: { type: "number", required: !0 } }, required: !1 }, sa = ({ params: e }) => H(ia, e), na = (e) => {
  let t = { "Content-Type": "multipart/form-data" };
  return e && e.headers && (t = { ...e.headers, ...t }, delete e.headers), Gt({ ...e, method: L.POST, getEndpoint: aa, preflightValidation: sa, headers: t });
}, oa = () => "https://dev.hivery.ai/api/v1/curate/preferences", wn = (e = !0, t) => O({ ...t, method: L.GET, getEndpoint: oa, tenantRequired: !1 }, { params: e }), pa = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v1/curate/products/${e.productId}`;
}, da = { id: "ParamsGetCurateProduct", type: "object", properties: { productId: { type: "integer", required: !0 } }, required: !0 }, Ea = ({ params: e }) => {
  const t = H(da, e);
  return !!t || t;
}, kn = (e, t) => O({ ...t, method: L.GET, getEndpoint: pa, preflightValidation: Ea }, e), _a = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v1/curate/scenarios/${e.scenarioId}/national-results`;
}, va = { id: "ParamsGetCurateProductSummaries", type: "object", properties: { scenarioId: { type: "integer", required: !0 } }, required: !0 }, ha = { id: "QueryGetCurateProductSummaries", type: "object", properties: { ordering: { type: "string", required: !0 } }, required: !0 }, ua = ({ params: e, query: t }) => {
  const s = H(va, e);
  if (!s) return s;
  const n = ne(ha, t);
  return !!n || n;
}, Kn = (e, t) => O({ ...t, method: L.GET, getEndpoint: _a, preflightValidation: ua }, e), ca = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v1/ie/documents/${e.documentId}/products/summaries`;
}, Aa = { id: "ParamsGetProductSummaries", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, Ia = { id: "QueryGetProductSummaries", type: "object", properties: { group_by: { type: "string", required: !0, minLength: 1 } }, required: !0 }, Ta = ({ params: e, query: t }) => {
  const s = H(Aa, e);
  if (!s) return s;
  const n = ne(Ia, t);
  return !!n || n;
}, $n = (e, t) => O({ ...t, method: L.GET, getEndpoint: ca, preflightValidation: Ta }, e), Sa = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v1/curate/projects/${e.projectId}/products${e.productId ? `/${e.productId}` : ""}`;
}, Pa = { id: "ParamsGetProducts", type: "object", properties: { projectId: { type: "integer", required: !0 }, productId: { type: "integer", required: !1 } }, required: !0 }, la = ({ params: e }) => H(Pa, e), xn = (e, t) => O({ ...t, method: L.GET, getEndpoint: Sa, preflightValidation: la }, e), fa = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v1/curate/projects/${e.projectId}`;
}, ya = { id: "ParamsDeleteProjects", type: "object", properties: { projectId: { type: "integer", required: !0 } }, required: !0 }, ma = ({ params: e }) => H(ya, e), Xn = (e, t) => O({ ...t, method: L.DELETE, getEndpoint: fa, preflightValidation: ma }, e), Ra = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v2/curate/projects/${e.projectId}/data-details`;
}, Ua = { id: "ParamsGetProjectDataDetails", type: "object", properties: { projectId: { type: "integer", required: !0 } }, required: !0 }, Na = ({ params: e }) => H(Ua, e), zn = (e, t) => O({ ...t, method: L.GET, getEndpoint: Ra, preflightValidation: Na }, e);
var La = ((e) => (e.SUCCESS = "success", e.PENDING = "pending", e.PROCESSING = "processing", e.FAILED = "failed", e))(La || {}), Ne = ((e) => (e.PSA = "PSA", e.PTS = "PTS", e))(Ne || {});
const ot = { UPDATED_ASC: "+updated_on", UPDATED_DES: "-updated_on" }, Oa = { FORECASTS: "forecasts", PRODUCTS: "products", STORES: "stores", SUPPLIERS: "suppliers", PLANOGRAMS: "planograms", C13NS: "c13ns" }, Zn = { PENDING: "pending", SUCCESS: "success", UNKNOWN: "", DONE: "done", PROCESSING: "processing" }, Ca = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v1/curate/projects/${e.projectId}/export-url/${e.fileType}`;
}, ga = { id: "ParamsGetProjectExportUrl", type: "object", properties: { projectId: { type: "integer", required: !0 }, fileType: { type: "string", required: !0, enum: Object.values(Oa) } }, required: !0 }, Da = ({ params: e }) => H(ga, e), Bn = (e, t) => O({ ...t, method: L.GET, getEndpoint: Ca, preflightValidation: Da }, e), Ha = () => "https://dev.hivery.ai/api/v1/curate/projects/file-upload-config", Wn = (e = !0, t) => O({ ...t, method: L.GET, getEndpoint: Ha }, { params: e }), Va = ({ params: e }) => `https://dev.hivery.ai/api/v1/curate/projects${e?.projectId ? `/${e?.projectId}` : ""}`, ba = { id: "ParamsGetProjects", type: "object", properties: { projectId: { type: "integer", required: !0 } }, required: !1 }, Ga = { id: "QueryGetProjects", type: "object", properties: { search: { type: "string", required: !1 }, limit: { type: "number", required: !1, minimum: 1, maximum: 100 }, offset: { type: "number", required: !1, minimum: 1 }, ordering: { type: "string", required: !0, enum: [ot.UPDATED_ASC, ot.UPDATED_DES] } }, required: !1 }, Ya = ({ params: e, query: t }) => e && Object.hasOwn(e, "projectId") ? H(ba, e) : ne(Ga, t), Jn = (e, t) => O({ ...t, method: L.GET, getEndpoint: Va, preflightValidation: Ya }, e), Fa = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v1/curate/projects/${e.projectId}`;
}, Ma = { id: "ParamsPatchProject", type: "object", properties: { projectId: { type: "integer", required: !0 } }, required: !0 }, qa = { id: "BodyPatchProject", type: "object", properties: { isArchive: { type: "boolean", required: !0 } } }, ja = ({ params: e, body: t }) => {
  const s = H(Ma, e);
  if (!s) return s;
  const n = J(qa, t);
  return !!n || n;
}, Qn = (e) => O({ ...e, method: L.PATCH, getEndpoint: Fa, preflightValidation: ja }), wa = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v2/curate/projects/${e.projectId}/settings`;
}, ka = { id: "ParamsPatchProjectSettings", type: "object", properties: { projectId: { type: "integer", required: !0 } }, required: !0 }, Ka = { id: "BodyPatchProjectSettings", type: "object", properties: { name: { type: "string", required: !0, minLength: 1 }, storesFile: { type: "string", required: !0, minLength: 1 }, productsFile: { type: "string", required: !0, minLength: 1 }, forecastsFile: { type: "string", required: !0, minLength: 1 }, suppliersFile: { type: "string", required: !0, minLength: 1 }, planogramsFile: { type: "string", required: !0, minLength: 0 }, planogramsFileFormat: { type: "string", enum: [Ne.PSA, Ne.PTS] }, planogramsFileNamingConvention: { type: "string", required: !0, minLength: 0 }, c13nsFile: { type: "string", required: !0, minLength: 0 }, changeC13nsFile: { type: "boolean", required: !0 } } }, $a = ({ params: e, body: t }) => {
  const s = H(ka, e);
  if (!s) return s;
  const n = J(Ka, t);
  return !!n || n;
}, eo = (e) => O({ ...e, method: L.PATCH, getEndpoint: wa, preflightValidation: $a }), pt = { SPACE: "space", ASSORTMENT: "assortment" }, to = { FORCE_PODS_IN: "force_pods_in", FORCE_PODS_OUT: "force_pods_out", POD_PRESENCE: "pod_presence", TARGET_PODS: "target_pods", TARGET_QUANTITY_SOLD: "target_quantity_sold", TARGET_REVENUE: "target_revenue", TARGET_DISTRIBUTION: "target_distribution", TARGET_PRODUCT_SLOTTING: "target_product_slotting", PROTECT_PODS: "protect_pods", PARENT_RELATIONSHIP: "parent_relationship", LIMIT_ASSORTMENT_CHURN: "limit_assortment_churn", SPECIFY_ASSORTMENT_PRIORITY: "specify_assortment_priority" }, ro = { ADJUST_AVAILABILITY: "adjust_availability", ADJUST_QUANITY_SOLD: "adjust_quantity_sold", ADJUST_REVENUE: "adjust_revenue", ADJUST_RANKING_PRIORITY: "adjust_ranking_priority", ADJUST_OBJECTIVE_VALUE: "adjust_objective_value" }, ao = { SPECIFY_UNIT_CAPACITY: "specify_unit_capacity", SPECIFTY_CASE_CAPACITY: "specify_case_capacity", RESTRICT_UNSALEABLES: "restrict_unsaleables", SPECIFY_DOS_THRESHOLD: "specify_dos_threshold", DOS_BOOST: "dos_boost", CONTROL_FACINGS_FOR_ORIENTATION: "control_facings_for_orientation", LIMIT_SPACE_CHURN: "limit_space_churn", SPACE_ALLOCATION: "space_allocation" }, io = { MATCH_PLACEMENT_HIERARCHICAL: "match_placement_hierarchical", ALLOWABLE_FIXTURE_TYPES: "allowable_fixture_types", ORIENTATIONS_FOR_MERCH_STYLE: "orientations_for_merch_style", SPECIFY_HEIGHT_FOR_STYLE: "specify_height_for_style", MAXIMUM_STACK_HEIGHT_FOR_STYLE: "maximum_stack_height_for_style", ALLOWED_MERCHANDIZE_STYLES: "allowed_merchandise_styles", SPECIFY_PLACEMENT_RANGE: "specify_placement_range" }, so = { RELATIVE_POSITIONING: "relative_positioning", SINGLE_SHELF: "single_shelf", SINGLE_SEGMENT: "single_segment", SINGLE_LEVEL: "single_level", DISALLOW_PRESENCE: "disallow_presence", CHAIN_FLOW: "chain_flow", CONTROL_ALIGNMENT: "control_alignment", CONTROL_OVER_UNDERS: "control_over_unders" }, xa = () => "https://dev.hivery.ai/api/v1/curate/projects", Xa = { id: "BodyPostProject", type: "object", properties: { algorithmTypes: { type: "array", required: !0, minItems: 1, items: { type: "string", enum: [pt.ASSORTMENT, pt.SPACE] }, additionalItems: !1 }, name: { type: "string", required: !0, minLength: 1 }, storesFile: { type: "string", required: !0, minLength: 1 }, productsFile: { type: "string", required: !0, minLength: 1 }, forecastsFile: { type: "string", required: !0, minLength: 1 }, suppliersFile: { type: "string", required: !0, minLength: 1 }, planogramsFile: { type: "string", required: !0, minLength: 0 }, planogramsFileFormat: { type: "string", enum: [Ne.PSA, Ne.PTS] }, planogramsFileNamingConvention: { type: "string", required: !0, minLength: 0 }, c13nsFile: { type: "string", required: !0, minLength: 0 }, c13nModelId: { type: "string", required: !0, minLength: 0 }, isCannibalisationOnly: { type: "boolean", required: !0 }, parameters: { type: "object", required: !0, properties: { podThresholds: { type: "string", required: !0, minLength: 0 }, productFlow: { type: "string", required: !0, minLength: 0 }, rankingWeights: { type: "string", required: !0, minLength: 0 } }, additionalProperties: !1 } } }, za = ({ body: e }) => J(Xa, e), no = (e) => O({ ...e, method: L.POST, getEndpoint: xa, preflightValidation: za }), Za = () => "https://dev.hivery.ai/api/v1/curate/constraint-types", Ba = { id: "QueryGetConstraintTypes", type: "object", properties: { algorithm_types: { type: "string", required: !0 } }, required: !1 }, Wa = ({ query: e }) => ne(Ba, e), oo = (e, t) => O({ ...t, method: L.GET, getEndpoint: Za, preflightValidation: Wa }, e), Ja = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v2/curate/projects/${e.projectId}/scenarios/${e.scenarioId}`;
}, Qa = { id: "ParamsDeleteScenario", type: "object", properties: { projectId: { type: "integer", required: !0 }, scenarioId: { type: "integer", required: !0 } }, required: !0 }, ei = ({ params: e }) => H(Qa, e), po = (e, t) => O({ ...t, method: L.DELETE, getEndpoint: Ja, preflightValidation: ei }, e), ti = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v1/curate/reviews${e.reviewId ? `/${e.reviewId}` : ""}`;
}, ri = { id: "ParamsGetReviews", type: "object", properties: { reviewId: { type: "integer", required: !1 } }, required: !1 }, ai = ({ params: e }) => H(ri, e), Eo = (e, t) => O({ ...t, method: L.GET, getEndpoint: ti, preflightValidation: ai }, e), ii = () => "https://dev.hivery.ai/api/v1/curate/scenarios/aggregation-options", _o = (e = !0, t) => O({ ...t, method: L.GET, getEndpoint: ii }, { params: e }), si = () => "https://dev.hivery.ai/api/v1/curate/scenarios/file-upload-config", vo = (e = !0, t) => O({ ...t, method: L.GET, getEndpoint: si }, { params: e }), ni = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v2/curate/projects/${e.projectId}/scenario-groups${e.groupId ? `/${e.groupId}` : ""}`;
}, oi = { id: "ParamsGetScenarioGroups", type: "object", properties: { projectId: { type: "integer", required: !0 }, groupId: { type: "integer", required: !1 } }, required: !0 }, pi = ({ params: e }) => H(oi, e), ho = (e, t) => O({ ...t, method: L.GET, getEndpoint: ni, preflightValidation: pi }, e);
var di = ((e) => (e.SUCCESS = "success", e.SUCCESS_WITH_INFEASIBILITY = "success_with_inf", e.UNOPTIMISED = "unoptimised", e.PEDNING = "pending", e.PROCESSING = "processing", e.PROCESSING_UNPOLLABLE = "processing_unpollable", e.FAILED = "failed", e))(di || {}), Ei = ((e) => (e.JOB_QUEUED = "job_queued", e.LOADING_DATA = "loading_data", e.SOLVING_MODEL = "solving_model", e.SAVING_RESULTS = "saving_results", e.PROCESSING = "processing", e.FAILED = "failed", e))(Ei || {}), _i = ((e) => (e.RULE = "rules_based", e.IE = "interactive", e))(_i || {}), vi = ((e) => (e.IMPORT_PENDING = "import_pending", e.IMPORT_PROCESSING = "import_processing", e.IMPORT_FAILED = "import_failed", e.EDIT_PENDING = "edit_pending", e.EDIT_FAILED = "edit_failed", e.READY = "ready", e.SAVED = "saved", e))(vi || {});
const be = { PRODUCT_ASC: "product", PRODUCT_DES: "-product", UPC_ASC: "product_upc", UPC_DES: "-product_upc" }, hi = { BRAND: "brand", SUB_BRAND: "subbrand", CATEGORY: "category", SUB_CATEGORY: "subcategory", SUB_SUB_CATEGORY: "subsubcategory", MANUFACTURER: "manufacturer", PACK_GROUP: "packgroup", PRODUCT_UPC: "product_upc", PRODUCT_GROUP: "product_group" }, ui = ({ params: e, query: t }) => {
  if (e)
    return `https://dev.hivery.ai/api/v1/curate/scenarios/${e.scenarioId}/national-results`;
}, ci = { id: "ParamsGetScenariosNationalResults", type: "object", properties: { scenarioId: { type: "integer", required: !0 } }, required: !0 }, Ai = { id: "QueryGetScenariosNationalResults", type: "object", properties: { ordering: { type: "string", required: !1, enum: [be.PRODUCT_ASC, be.PRODUCT_DES, be.UPC_ASC, be.UPC_DES] }, groupings: { type: "array", required: !1, items: { type: "string", uniqueItems: !0, enum: Object.entries(hi).map((e, t) => t) } } } }, Ii = ({ params: e, query: t }) => {
  const s = H(ci, e);
  if (!s) return s;
  const n = ne(Ai, t);
  return !!n || n;
}, Ti = (e) => {
  const t = {};
  return e.ordering && (t.ordering = e.ordering), e.groupBy && (t["group-by"] = e.groupBy.join(",")), t;
}, uo = (e, t) => O({ ...t, method: L.GET, getEndpoint: ui, preflightValidation: Ii, formatQuery: Ti }, e), Si = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v2/curate/projects/${e.projectId}/scenarios${e.scenarioId ? `/${e.scenarioId}` : ""}`;
}, Pi = { id: "ParamsGetScenarios", type: "object", properties: { projectId: { type: "integer", required: !0 }, scenarioId: { type: "integer", required: !1 } }, required: !0 }, li = ({ params: e }) => H(Pi, e), co = (e, t) => O({ ...t, method: L.GET, getEndpoint: Si, preflightValidation: li }, e), fi = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v2/curate/projects/${e.projectId}/scenarios-base-core`;
}, yi = { id: "ParamsGetScenariosBaseCore", type: "object", properties: { projectId: { type: "integer", required: !0 } }, required: !0 }, mi = ({ params: e }) => H(yi, e), Ao = (e, t) => O({ ...t, method: L.GET, getEndpoint: fi, preflightValidation: mi }, e), Ri = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v2/curate/projects/${e.projectId}/scenarios/${e.reviewId}`;
}, Ui = { id: "ParamsPatchReview", type: "object", properties: { projectId: { type: "integer", required: !0 }, reviewId: { type: "integer", required: !0 } }, required: !0 }, Ni = { id: "BodyPatchReview", type: "object", properties: { isArchived: { type: "boolean", required: !0 } } }, Li = ({ params: e, body: t }) => {
  const s = H(Ui, e);
  if (!s) return s;
  const n = J(Ni, t);
  return !!n || n;
}, Io = (e) => O({ ...e, method: L.PATCH, getEndpoint: Ri, preflightValidation: Li }), Oi = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v2/curate/projects/${e.projectId}/scenarios/${e.scenarioId}`;
}, Ci = { id: "ParamsPatchScenario", type: "object", properties: { projectId: { type: "integer", required: !0 }, scenarioId: { type: "integer", required: !0 } }, required: !0 }, gi = ({ params: e }) => H(Ci, e), To = (e) => O({ ...e, method: L.PATCH, getEndpoint: Oi, preflightValidation: gi }), Di = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v2/curate/projects/${e.projectId}/scenarios/${e.scenarioId}/assign-group`;
}, Hi = { id: "ParamsPatchScenarioAssignGroup", type: "object", properties: { projectId: { type: "integer", required: !0 }, scenarioId: { type: "integer", required: !0 } }, required: !0 }, Vi = { id: "BodyPatchScenarioGroupRename", type: "object", properties: { groupId: { type: "string", required: !0, minLength: 1 } } }, bi = ({ params: e, body: t }) => {
  const s = H(Hi, e);
  if (!s) return s;
  const n = J(Vi, t);
  return !!n || n;
}, So = (e) => O({ ...e, method: L.PATCH, getEndpoint: Di, preflightValidation: bi }), Gi = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v2/curate/projects/${e.projectId}/scenario-groups/${e.groupId}/archive`;
}, Yi = { id: "ParamsPatchScenarioGroupArchive", type: "object", properties: { projectId: { type: "integer", required: !0 }, groupId: { type: "integer", required: !0 } }, required: !0 }, Fi = ({ params: e }) => H(Yi, e), Po = (e) => O({ ...e, method: L.PATCH, getEndpoint: Gi, preflightValidation: Fi }), Mi = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v2/curate/projects/${e.projectId}/scenario-groups/${e.groupId}/undo-archive`;
}, qi = { id: "ParamsPatchScenarioGroupArchiveUndo", type: "object", properties: { projectId: { type: "integer", required: !0 }, groupId: { type: "integer", required: !0 } }, required: !0 }, ji = ({ params: e }) => H(qi, e), lo = (e) => O({ ...e, method: L.PATCH, getEndpoint: Mi, preflightValidation: ji }), wi = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v2/curate/projects/${e.projectId}/scenario-groups/${e.groupId}/rename`;
}, ki = { id: "ParamsPatchScenarioGroupRename", type: "object", properties: { projectId: { type: "integer", required: !0 }, groupId: { type: "integer", required: !0 } }, required: !0 }, Ki = { id: "BodyPatchScenarioGroupRename", type: "object", properties: { name: { type: "string", required: !0, minLength: 1 } } }, $i = ({ params: e, body: t }) => {
  const s = H(ki, e);
  if (!s) return s;
  const n = J(Ki, t);
  return !!n || n;
}, fo = (e) => O({ ...e, method: L.PATCH, getEndpoint: wi, preflightValidation: $i }), xi = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v1/curate/scenarios/${e.scenarioId}/push_to_review`;
}, Xi = { id: "ParamsPostReview", type: "object", properties: { scenarioId: { type: "integer", required: !0 } }, required: !0 }, zi = { id: "BodyPostReview", type: "object", properties: { name: { type: "string", required: !0, minLength: 1 } } }, Zi = ({ params: e, body: t }) => {
  const s = H(Xi, e);
  if (!s) return s;
  const n = J(zi, t);
  return !!n || n;
}, yo = (e) => O({ ...e, method: L.POST, getEndpoint: xi, preflightValidation: Zi }), Bi = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v2/curate/projects/${e.projectId}/scenario-groups`;
}, Wi = { id: "ParamsPostScenarioGroups", type: "object", properties: { projectId: { type: "integer", required: !0 } }, required: !0 }, Ji = { id: "BodyPostScenarioGroups", type: "object", properties: { name: { type: "string", required: !0, minLength: 1 }, orderIndex: { type: "number", required: !0 } } }, Qi = ({ params: e, body: t }) => {
  const s = H(Wi, e);
  if (!s) return s;
  const n = J(Ji, t);
  return !!n || n;
}, mo = (e) => O({ ...e, method: L.POST, getEndpoint: Bi, preflightValidation: Qi }), es = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v1/ie/documents/${e.documentId}/clusters/${e.clusterId}/planograms`;
}, ts = { id: "ParamsGetClusterPlanograms", type: "object", properties: { documentId: { type: "integer", required: !0 }, clusterId: { type: "integer", required: !0 } }, required: !0 }, rs = ({ params: e }) => H(ts, e), Ro = (e, t) => O({ ...t, method: L.GET, getEndpoint: es, preflightValidation: rs }, e), as = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v1/curate/scenarios/${e.scenarioId}/store-results/${e.storeId}`;
}, is = { id: "ParamsGetCurateStoreProducts", type: "object", properties: { scenarioId: { type: "integer", required: !0 }, storeId: { type: "integer", required: !0 } }, required: !0 }, ss = { id: "QueryGetCurateProductSummaries", type: "object", properties: { ordering: { type: "string", required: !0 } }, required: !0 }, ns = ({ params: e, query: t }) => {
  const s = H(is, e);
  if (!s) return s;
  const n = ne(ss, t);
  return !!n || n;
}, Uo = (e, t) => O({ ...t, method: L.GET, getEndpoint: as, preflightValidation: ns }, e), os = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v2/curate/projects/${e.projectId}/scenarios/${e.scenarioId}/store-list`;
}, ps = { id: "ParamsGetCurateStores", type: "object", properties: { projectId: { type: "integer", required: !0 }, scenarioId: { type: "integer", required: !0 } }, required: !0 }, ds = { id: "QueryGetCurateProductSummaries", type: "object", properties: { offset: { type: "integer", required: !0 }, limit: { type: "integer", required: !0 }, ordering: { type: "string", required: !0 }, direction: { type: "string", required: !0 }, agg_vals: { type: "string", required: !0 }, aggregation: { type: "string", required: !0 } }, required: !0 }, Es = ({ params: e, query: t }) => {
  const s = H(ps, e);
  if (!s) return s;
  const n = ne(ds, t);
  return !!n || n;
}, No = (e, t) => O({ ...t, method: L.GET, getEndpoint: os, preflightValidation: Es }, e), _s = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v1/ie/documents/${e.documentId}/stores/kpi_summary`;
}, vs = { id: "ParamsGetStoreKpiSummaries", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, hs = ({ params: e }) => H(vs, e), Lo = (e, t) => O({ ...t, method: L.GET, getEndpoint: _s, preflightValidation: hs }, e), us = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v1/ie/documents/${e.documentId}/stores/${e.storeId}/planograms`;
}, cs = { id: "ParamsGetStoresPlanograms", type: "object", properties: { documentId: { type: "integer", required: !0 }, storeId: { type: "integer", required: !0 } }, required: !0 }, As = ({ params: e }) => H(cs, e), Oo = (e, t) => O({ ...t, method: L.GET, getEndpoint: us, preflightValidation: As }, e), Is = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v1/ie/documents/${e.documentId}/stores/summaries`;
}, Ts = { id: "ParamGetStoresSummaries", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, Ss = { id: "QueryGetStoreSummaries", type: "object", properties: { group_by: { type: "string", required: !0, minLength: 1 } }, required: !0 }, Ps = ({ params: e, query: t }) => {
  const s = H(Ts, e);
  if (!s) return s;
  const n = ne(Ss, t);
  return !!n || n;
}, Co = (e, t) => O({ ...t, method: L.GET, getEndpoint: Is, preflightValidation: Ps }, e), ls = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v1/ie/documents/${e.documentId}/stores/planograms-export`;
}, fs = { id: "ParamsPostExportPlanograms", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, ys = ({ params: e }) => H(fs, e), go = () => {
  const [e, t] = G(!1), [s, n] = G(), [c, P] = G(), [T, y, C, U] = ct(), p = b((v) => {
    if (typeof v == "string") n(v), t(!1);
    else if (v instanceof Object && Object.hasOwn(v, "taskId")) C({ params: { taskId: v.taskId } });
    else {
      const l = { isError: !0, data: { type: "process-error", error_code: "UnknownResponse", status_code: -1, message: "unknown response type from posting assortment request", response: v } };
      P(l), console.warn(l);
    }
    return v;
  }, [C]), d = b((v) => {
    P(v), t(!1);
  }, []), [S, A, a] = O({ method: L.POST, getEndpoint: ls, preflightValidation: ys, onSuccess: p, onFailure: d }), _ = b((v) => {
    t(!0), a({ ...v, body: void 0 });
  }, [a]);
  return Q(() => {
    T || (U ? console.warn(U) : (n(y), t(!1)));
  }, [T, y, U]), ae(() => [e, s, _, c], [c, s, e, _]);
};
var ms = ((e) => (e.UNIT = "UNIT", e.TRAY = "TRAY", e.CASE = "CASE", e.DISPLAY = "DISPLAY", e.ALTERNATE = "ALTERNATE", e))(ms || {}), Rs = ((e) => (e.FIXTURE = "Fixture", e.SHELF = "Shelf", e.FLOATING = "FloatingShelf", e))(Rs || {});
const Us = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v1/strategies/${e.strategy_id}/aggregation`;
}, Ns = { id: "ParamsGetStrategyAggregation", type: "object", properties: { strategy_id: { type: "string", required: !0 } }, required: !0 }, Ls = { id: "QueryGetStrategyAggregation", type: "object", properties: { aggregation: { type: "string", required: !0, minLength: 1 } }, required: !0 }, Os = ({ params: e, query: t }) => {
  const s = H(Ns, e);
  if (!s) return s;
  const n = ne(Ls, t);
  return !!n || n;
}, Do = (e, t) => O({ ...t, method: L.GET, getEndpoint: Us, preflightValidation: Os }, e);
var Cs = ((e) => (e.CALCULATE = "calculate", e.RESET = "reset", e.SAVE = "save", e))(Cs || {}), ye = ((e) => (e.NOT_READY = "not_ready", e.READY = "ready", e.PENDING = "pending", e.IN_PROGRESS = "in_progress", e.READ_ONLY = "read_only", e))(ye || {}), Ee = ((e) => (e.NAME_ASC = "+name", e.NAME_DES = "-name", e.CREATED_ASC = "+created_on", e.CREATED_DES = "-created_on", e.UPDATED_ASC = "+updated_on", e.UPDATED_DES = "-updated_on", e.ARCHIVED_ASC = "+archived_on", e.ARCHIVED_DES = "-archived_on", e))(Ee || {}), gs = ((e) => (e.CATEGORY = "category", e.SUB_CATEGORY = "sub_category", e.BRAND = "brand", e.SUB_BRAND = "sub_brand", e.PACK_GROUP = "pack_group", e))(gs || {});
const Ds = ({ params: e, query: t }) => {
  const s = { ENV: "dev", HIVEMIND_ENV: "dev.hivery.ai", CY_TEST: "true", JEST: !1, ALLOW_PASSWORD_LOGIN: "true", CURATE_API_V1: "https://dev.hivery.ai/api/v1/curate", CURATE_API_V2: "https://dev.hivery.ai/api/v2/curate", INTERACTIVE_EDIT_API: "https://dev.hivery.ai/api/v1/ie", PREDICTION_API: "https://dev.hivery.ai/api/v1/prediction", SSDI_API: "https://dev.hivery.ai/api/v1/ssdi", SSDI_API_V2: "https://dev.hivery.ai/api/v2/ssdi", STRATEGY_API: "https://dev.hivery.ai/api/v1/strategies", AGENT_API: "https://dev.hivery.ai/api/v1/agent", FILES_API_HOST: "", AUTH0_CLIENT_ID: "pkcXkULYXQfYaFHpeb6BVPRoP0V1XIJN", AUTH0_DOMAIN: "auth.dev.hivery.ai", AUTH0_AUDIENCE: "propel-api-dev", PUSHER_APP_KEY: "1a2f9c6611892edf8b3f", PUSHER_CLUSTER: "us3", PUSHER_IE_APP_KEY: "1a2f9c6611892edf8b3f", PUSHER_IE_CLUSTER: "us3", UNLEASH_URL: "https://zero.hivery.ai/unleash/api/frontend", UNLEASH_TOKEN: "*:development.73b148c1e2fe6b2e0aeedfe610ee2d6e8c5890dea9f00e6a08c8638d", UNLEASH_ENV: "development", OTEL_KEY: "", OTEL_COLLECTOR_URL: "https://dev.hivery.ai/collect", OTEL_SERVICE_NAME: "", PRODUCT_IMAGE_HOST: "dev", AZURE_CDN_DOMAIN: "https://app.dev.hivery.ai" };
  return typeof e == "boolean" ? `${s.STRATEGY_API}` : e || t ? t ? `${s.STRATEGY_API}` : e ? `${s.STRATEGY_API}/${e.strategy_id}` : void 0 : void 0;
}, Hs = { id: "ParamsGetStrategies", type: "object", properties: { strategy_id: { type: "string", required: !1 } }, required: !1 }, Vs = { id: "QueryGetStrategies", type: "object", properties: { project_id: { type: "integer", required: !1 }, dataset_id: { type: "string", required: !1 }, model_id: { type: "string", required: !1 }, assortment_id: { type: "string", required: !1 }, kpi_id: { type: "string", required: !1 }, planogram_id: { type: "string", required: !1 }, state_status: { type: "string", required: !1, enum: [ye.NOT_READY, ye.READY, ye.PENDING, ye.IN_PROGRESS, ye.READ_ONLY] }, order_by: { type: "string", required: !1, enum: [Ee.NAME_ASC, Ee.NAME_DES, Ee.CREATED_ASC, Ee.CREATED_DES, Ee.UPDATED_ASC, Ee.UPDATED_DES, Ee.ARCHIVED_ASC, Ee.ARCHIVED_DES] }, limit: { type: "number", required: !1, minimum: 1, maximum: 100 }, offset: { type: "number", required: !1, minimum: 1 } }, required: !1 }, bs = ({ params: e, query: t }) => {
  let s = !0;
  if (typeof e == "boolean") return !0;
  if (s = H(Hs, e), !s) return s;
  const n = ne(Vs, t);
  return !!n || n;
}, Ho = (e, t) => {
  let s;
  return typeof e == "boolean" ? s = { params: e } : s = e, O({ ...t, method: L.GET, getEndpoint: Ds, preflightValidation: bs }, s);
}, Gs = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v1/strategies/${e.strategy_id}/generate-data`;
}, Ys = { id: "ParamsPostStrategyGenerateData", type: "object", properties: { strategy_id: { type: "string", required: !0 } }, required: !0 }, Fs = { id: "BodyPostStrategyGenerateData", type: "object", properties: { stores: { type: "integer", required: !0 }, categories: { type: "integer", required: !0 }, sub_categories: { type: "integer", required: !0 }, brands: { type: "integer", required: !0 }, sub_brands: { type: "integer", required: !0 }, pack_groups: { type: "integer", required: !0 }, products: { type: "integer", required: !0 }, dist_min: { type: "integer", required: !0 }, dist_max: { type: "integer", required: !0 } }, required: !0 }, Ms = ({ params: e, body: t }) => {
  const s = H(Ys, e);
  if (!s) return s;
  const n = J(Fs, t);
  return !!n || n;
}, Vo = (e) => O({ ...e, method: L.POST, getEndpoint: Gs, preflightValidation: Ms }), qs = ({ params: e }) => {
  if (e)
    return `https://dev.hivery.ai/api/v1/strategies/${e.strategy_id}/ingest-data`;
}, js = { id: "ParamsPostStrategyIngestData", type: "object", properties: { strategy_id: { type: "string", required: !0 } }, required: !0 }, ce = { type: "array", required: !0, minItems: 1, items: { type: "string" }, additionalItems: !1 }, ws = { id: "BodyPostStrategyIngestData", type: "object", properties: { descriptors: { type: "object", properties: { brands: ce, subBrands: ce, categories: ce, subCategories: ce, subSubCategories: ce, manufacturers: ce, packGroups: ce, productGroups: ce } }, products: { type: "array", required: !0, minItems: 1, items: { type: "object", properties: { id: { type: "integer", required: !0 }, upc: { type: "string", required: !0 }, name: { type: "string", required: !0 }, brand: { type: "string", required: !0 }, subBrand: { type: "string", required: !0 }, category: { type: "string", required: !0 }, subCategory: { type: "string", required: !0 }, subSubCategory: { type: "string", required: !0 }, packGroup: { type: "string", required: !0 }, productGroup: { type: "string", required: !0 }, storeIds: { type: "array", required: !0, items: { type: "integer" }, additionalItems: !1 }, podCount: { type: "integer", required: !0 }, weeklyMovement: { type: "number", required: !0 }, weeklyRevenue: { type: "number", required: !0 } } }, additionalItems: !1 } }, required: !0 }, ks = ({ params: e, body: t }) => {
  const s = H(js, e);
  if (!s) return s;
  const n = J(ws, t);
  return !!n || n;
}, bo = (e) => O({ ...e, method: L.POST, getEndpoint: qs, preflightValidation: ks }), Ks = () => "https://dev.hivery.ai/api/v1/strategies/", $s = { id: "BodyPostStrategies", type: "object", properties: { project_id: { type: "integer", required: !0 }, scenario_id: { type: "integer", required: !0 }, name: { type: "string", required: !0, minLength: 1 } }, required: !0 }, xs = ({ body: e }) => J($s, e), Go = (e) => O({ ...e, method: L.POST, getEndpoint: Ks, preflightValidation: xs }), Xs = () => "https://dev.hivery.ai/api/v1/curate/users/customer-groups", Yo = (e = !0, t) => O({ ...t, method: L.GET, getEndpoint: Xs }, { params: e }), zs = () => "https://dev.hivery.ai/api/v1/curate/users/me", Fo = (e = !0, t) => O({ ...t, method: L.GET, getEndpoint: zs, tenantRequired: !1 }, { params: e }), Zs = () => "https://dev.hivery.ai/api/v1/curate/users/customer-groups", Bs = { id: "BodyPatchUserCustomerGroup", type: "object", properties: { id: { type: "integer", required: !0 } } }, Ws = ({ body: e }) => J(Bs, e), Mo = (e) => O({ ...e, method: L.PATCH, getEndpoint: Zs, preflightValidation: Ws }), Js = () => "https://dev.hivery.ai/api/v1/curate/passwordless/send-email", Qs = { id: "BodyPostLoginPasswordless", type: "object", properties: { email: { type: "string", required: !0, minLength: 1 } } }, en = ({ body: e }) => J(Qs, e), qo = (e) => O({ ...e, method: L.POST, getEndpoint: Js, preflightValidation: en, authRequired: !1 }), tn = ({ base_params: e, sendForm: t, maxChunks: s = 10, chunkSize: n = 2097152 }) => {
  const [c, P] = G(!1), [T, y] = G(), C = (U, p, d) => {
    const S = new FormData();
    return U.forEach((A, a) => {
      S.append(`${d + a}-${p}`, A);
    }), S;
  };
  return [c, b((U, p) => {
    const d = U.type, S = U.name, A = U.stream().getReader({ mode: "byob" });
    return y(Math.ceil(U.size / n / s)), new Promise((a, _) => {
      let v = new Uint8Array(n), l = new Uint8Array(n), m = 0, D = 0, i = [], r = 0, E = {};
      e || p ? (e && (E = { ...e }), p && (E = { ...p }), P(!0), A.read(v).then(async function h({ done: o, value: f }) {
        if (o) {
          const u = new Uint8Array(m);
          u.set(l.slice(0, m));
          const I = new Blob([u], { type: d });
          i.push(I), D++;
          const N = C(i, S, r * s), g = { params: { ...E, part_number: r }, body: N };
          return r++, console.debug(`readStream() complete. Total Form Count: ${r}`), await t(g), a({ readComplete: !0, partCount: D, formCount: r }), void P(!1);
        }
        if (v = new Uint8Array(n), m + f.byteLength > n) {
          const u = n - m, I = new Uint8Array(n);
          I.set(l), I.set(f.slice(0, u), u);
          const N = new Blob([I], { type: d });
          i.push(N), D++, l = new Uint8Array(n), l.set(f.slice(u + 1, f.byteLength)), m = f.byteLength - (u + 1);
        } else if (l.set(f, m), m += f.byteLength, m === n) {
          const u = new Blob([l], { type: d });
          i.push(u), D++, l = new Uint8Array(n), m = 0;
        }
        if (D === s) {
          const u = C(i, S, r * s), I = { params: { ...E, part_number: r }, body: u };
          r++, await t(I), D = 0, i = [];
        }
        return A.read(v).then(h);
      })) : _({ readComplete: !1, partCount: D, formCount: r, isError: !0, error: "Unable to build file forms: missing request params" });
    });
  }, [n, s, e, t]), T];
}, we = 1048576, dt = 1024 * we, It = _t(null), jo = () => {
  const e = vt(It);
  if (!e) throw new Error("useFileUploadContextSSDI must be used within a FileUploadSSDIProvider");
  return e;
}, rn = St(({ children: e, kind: t, ...s }, n) => {
  const [c, P] = G(null), [T, y] = G(null), [C, U] = G(!1), [p, d] = G(!1), [S, A] = G(!1), [a, _] = G(!1), [v, l] = G(!1), [m, D] = G([]), [i, r] = G(), [E, h] = G(0), o = re(0), [f, u] = G(), I = ae(() => {
    if (!c) return;
    const V = c.size;
    return V < we ? `${(V / 1024).toFixed(2)}KB` : V < dt ? `${(V / we).toFixed(2)}MB` : `${(V / dt).toFixed(2)}GB`;
  }, [c]), [N, g, K, q] = Wr(), [x, ve, j, B] = ra(), ie = b(() => {
    h((V) => V + 1);
  }, []), he = b(() => {
    if (!(x || v || B)) if (i) if (g) if (T) {
      if (E === i.formCount) {
        const V = (performance.now() - o.current) / 1e3, Y = mt(m, "part").map((z) => z.id);
        u(V), _(!0), A(!1), j({ params: { id: g.id }, body: { filePartIds: Y, kind: g.kind, ext: T } });
      }
    } else console.debug("unable to process uploaded file: file ext not known");
    else console.debug("unable to process uploaded file empty queue: file meta data missing");
    else console.debug("unable to process uploaded file empty queue: file stats missing");
  }, [T, E, i, m, B, j, v, x, g]), Se = b((V) => {
    D((Y) => V.isError ? Y : [...Y, { id: V.data.id, part: V.data.partNumber }]);
  }, []), [Ie, Oe] = na({ headers: { "X-File-Upload-Kind": t }, onFinish: ie, onEmptyQueue: he, onResponse: Se }), [me, Ce, Re] = tn({ sendForm: Oe }), ge = b((V) => {
    l(!1), _(!1), A(!1), d(!1), U(!1), r(void 0), h(0), u(void 0), o.current = 0;
    const Y = yt(V.type);
    Y && (y(Y), P(V));
  }, []), De = b(() => {
    !C && c && (l(!1), _(!1), A(!1), d(!1), r(void 0), h(0), u(void 0), o.current = 0, U(!0), K({ body: { kind: t, name: c.name } }));
  }, [c, C, t, K]), R = ae(() => ({ isFileInProgress: C, isFilePrepared: p, isFilePreparing: N, isFileUploaded: a, isFileUploading: S, isFileFinialized: v, isFileFinializing: x, fileRequestCount: E, fileRequestExpectedCount: Re, fileStats: i, fileSizeLabel: I, fileUploadDuration: f, setFile: ge, sendFile: De, fileUploadError: q || B }), [E, Re, I, i, f, B, v, x, C, p, N, a, S, q, De, ge]);
  return Q(() => {
    q && U(!1);
  }, [q]), Q(() => {
    !c || !g || me || Ie || S || a || (o.current = performance.now(), Ce(c, { id: g.id }).then((V) => {
      r(V);
    }), u(void 0), A(!0), d(!0));
  }, [Ce, c, me, x, a, S, Ie, g]), Q(() => {
    B && U(!1);
  }, [B]), Q(() => {
    ve && (l(!0), U(!1));
  }, [ve]), Me.jsx(It.Provider, { value: R, children: Me.jsx("div", { ref: n, ...s, children: e }) });
});
rn.displayName = "FileUploadSSDIProvider";
export {
  rr as AGENT_ASSISTANT_TYPES,
  Sn as AGENT_MESSAGE_CONTENT_CHART_DATA_FIELD_KINDS,
  Pn as AGENT_MESSAGE_CONTENT_CHART_GEOMETRY_KINDS,
  ln as AGENT_MESSAGE_CONTENT_CHART_IMAGE_MIME_KINDS,
  Tn as AGENT_MESSAGE_CONTENT_KINDS,
  ir as AGENT_MESSAGE_ROLES,
  In as AGENT_MESSAGE_STATUSES,
  fn as AGENT_RUN_STATUSES,
  ar as AGENT_THREAD_SCOPE_LEVELS,
  pt as ALGORITHM_TYPES,
  Dr as AssortedStatus,
  to as CONSTRAINT_KINDS_ASSORTMENT_CONTROLS,
  ro as CONSTRAINT_KINDS_ASSORTMENT_OVERRIDES,
  io as CONSTRAINT_KINDS_SPACE_APPEARANCE,
  ao as CONSTRAINT_KINDS_SPACE_LIMIT,
  so as CONSTRAINT_KINDS_SPACE_MERCHANDIZING,
  Mr as DocumentState,
  Ut as DomExceptionName,
  _e as EditRequestsCommandTypes,
  je as EditRequestsStatuses,
  Zn as FILE_EXPORT_STATUS,
  Oa as FILE_EXPORT_TYPE,
  L as FetchMethod,
  It as FileUploadContextSSDI,
  rn as FileUploadSSDIProvider,
  Rs as FixtureType,
  ot as GET_PROJECT_ORDER_BY,
  ms as MerchandiseStyle,
  Ne as PlanogramFileFormat,
  La as ProjectImportStatuses,
  hi as SCENARIO_NATIONAL_RESULTS_GROUPINGS,
  be as SCENARIO_NATIONAL_RESULTS_ORDER,
  Ei as ScenarioOptimizationCodes,
  di as ScenarioOptimizationStatuses,
  vi as ScenarioReviewMetaStatuses,
  _i as ScenarioType,
  qa as SchemaBodyPatchProject,
  Ka as SchemaBodyPatchProjectSettings,
  Ni as SchemaBodyPatchReview,
  Vi as SchemaBodyPatchScenarioAssignGroup,
  Ki as SchemaBodyPatchScenarioGroupRename,
  Bs as SchemaBodyPatchUserCustomerGroup,
  nr as SchemaBodyPostAgentAssistant,
  Er as SchemaBodyPostAgentMessage,
  ur as SchemaBodyPostAgentRun,
  Ir as SchemaBodyPostAgentThread,
  Zr as SchemaBodyPostFilesUpload,
  ea as SchemaBodyPostFilesUploadComplete,
  Qs as SchemaBodyPostLoginPasswordless,
  Xa as SchemaBodyPostProject,
  zi as SchemaBodyPostReview,
  Ji as SchemaBodyPostScenarioGroups,
  $s as SchemaBodyPostStrategies,
  Fs as SchemaBodyPostStrategyGenerateData,
  ws as SchemaBodyPostStrategyIngestData,
  ya as SchemaParamsDeleteProjects,
  Qa as SchemaParamsDeleteScenario,
  jt as SchemaParamsGetAgentAssistants,
  Kt as SchemaParamsGetAgentMessage,
  Xt as SchemaParamsGetAgentRun,
  Bt as SchemaParamsGetAgentThreads,
  Pr as SchemaParamsGetAssortment,
  ts as SchemaParamsGetClusterPlanograms,
  da as SchemaParamsGetCurateProduct,
  va as SchemaParamsGetCurateProductSummaries,
  is as SchemaParamsGetCurateStoreProducts,
  ps as SchemaParamsGetCurateStores,
  Vr as SchemaParamsGetDocuments,
  Yr as SchemaParamsGetDocumentsSummaries,
  jr as SchemaParamsGetEditRequestsMostRecent,
  yr as SchemaParamsGetPODS,
  Aa as SchemaParamsGetProductSummaries,
  Pa as SchemaParamsGetProducts,
  Ua as SchemaParamsGetProjectDataDetails,
  ga as SchemaParamsGetProjectExportUrl,
  ba as SchemaParamsGetProjects,
  ri as SchemaParamsGetReviews,
  oi as SchemaParamsGetScenarioGroups,
  Pi as SchemaParamsGetScenarios,
  yi as SchemaParamsGetScenariosBaseCore,
  ci as SchemaParamsGetScenariosNationalResults,
  vs as SchemaParamsGetStoreKpiSummaries,
  cs as SchemaParamsGetStoresPlanograms,
  Ts as SchemaParamsGetStoresSummaries,
  Hs as SchemaParamsGetStrategies,
  Ns as SchemaParamsGetStrategyAggregation,
  Ur as SchemaParamsGetTasksStatus,
  Qt as SchemaParamsListAgentMessages,
  Ma as SchemaParamsPatchProject,
  ka as SchemaParamsPatchProjectSettings,
  Ui as SchemaParamsPatchReview,
  Ci as SchemaParamsPatchScenario,
  Hi as SchemaParamsPatchScenarioAssignGroup,
  Yi as SchemaParamsPatchScenarioGroupArchive,
  qi as SchemaParamsPatchScenarioGroupArchiveUndo,
  ki as SchemaParamsPatchScenarioGroupRename,
  dr as SchemaParamsPostAgentMessage,
  hr as SchemaParamsPostAgentRun,
  $r as SchemaParamsPostEditRequestsCreate,
  Cr as SchemaParamsPostExportAssortment,
  fs as SchemaParamsPostExportPlanograms,
  Qr as SchemaParamsPostFilesUploadComplete,
  ia as SchemaParamsPostFilesUploadPart,
  Xi as SchemaParamsPostReview,
  Wi as SchemaParamsPostScenarioGroups,
  Ys as SchemaParamsPostStrategyGenerateData,
  js as SchemaParamsPostStrategyIngestData,
  Ba as SchemaQueryGetConstraintTypess,
  ha as SchemaQueryGetCurateProductSummaries,
  ss as SchemaQueryGetCurateStoreProducts,
  ds as SchemaQueryGetCurateStores,
  Ia as SchemaQueryGetProductSummaries,
  Ga as SchemaQueryGetProjects,
  Ai as SchemaQueryGetScenariosNationalResults,
  Ss as SchemaQueryGetStoreSummaries,
  Vs as SchemaQueryGetStrategies,
  Ls as SchemaQueryGetStrategyAggregation,
  er as SchemaQueryListAgentMessages,
  Ee as StrategiesOrderBy,
  gs as StrategyAggregationType,
  ye as StrategyStatusType,
  Cs as StrategyTaskType,
  fe as TaskStatuses,
  At as UPLOAD_FILE_KINDS,
  jn as UPLOAD_FILE_STATUSES,
  ut as UserStateContext,
  Vt as UserStateContextInit,
  ht as UserStateInit,
  dn as UserStateProvider,
  Ye as cleanQueryParams,
  fa as endpointDeleteProjects,
  Ja as endpointDeleteScenario,
  qt as endpointGetAgentAssistants,
  kt as endpointGetAgentMessage,
  xt as endpointGetAgentRun,
  Zt as endpointGetAgentThreads,
  Sr as endpointGetAssortment,
  es as endpointGetClusterPlanograms,
  Za as endpointGetConstraintTypess,
  pa as endpointGetCurateProduct,
  _a as endpointGetCurateProductSummaries,
  as as endpointGetCurateStoreProducts,
  os as endpointGetCurateStores,
  Xs as endpointGetCustomerGroups,
  Hr as endpointGetDocuments,
  Gr as endpointGetDocumentsSummaries,
  qr as endpointGetEditRequestsMostRecent,
  zs as endpointGetMe,
  fr as endpointGetPODs,
  oa as endpointGetPreferences,
  ca as endpointGetProductSummaries,
  Sa as endpointGetProducts,
  Ra as endpointGetProjectDataDetails,
  Ca as endpointGetProjectExportUrl,
  Va as endpointGetProjects,
  Ha as endpointGetProjectsFileUploadConfig,
  ti as endpointGetReviews,
  ii as endpointGetScenarioAggregationOptions,
  si as endpointGetScenarioFileUploadConfig,
  ni as endpointGetScenarioGroups,
  Si as endpointGetScenarios,
  fi as endpointGetScenariosBaseCore,
  ui as endpointGetScenariosNationalResults,
  _s as endpointGetStoreKpiSummaries,
  us as endpointGetStoresPlanograms,
  Ds as endpointGetStrategies,
  Us as endpointGetStrategyAggregation,
  Rr as endpointGetTasksStatus,
  Xr as endpointGetTestAuth,
  Jt as endpointListAgentMessages,
  Fa as endpointPatchProject,
  wa as endpointPatchProjectSettings,
  Ri as endpointPatchReview,
  Oi as endpointPatchScenario,
  Di as endpointPatchScenarioAssignGroup,
  Gi as endpointPatchScenarioGroupArchive,
  Mi as endpointPatchScenarioGroupArchiveUndo,
  wi as endpointPatchScenarioGroupRename,
  Zs as endpointPatchUserCustomerGroup,
  sr as endpointPostAgentAssistant,
  pr as endpointPostAgentMessage,
  vr as endpointPostAgentRun,
  Ar as endpointPostAgentThread,
  Kr as endpointPostEditRequestsCreate,
  Or as endpointPostExportAssortment,
  ls as endpointPostExportPlanograms,
  zr as endpointPostFilesUpload,
  Jr as endpointPostFilesUploadComplete,
  aa as endpointPostFilesUploadPart,
  Js as endpointPostLoginPasswordless,
  xa as endpointPostProject,
  xi as endpointPostReview,
  Bi as endpointPostScenarioGroups,
  Ks as endpointPostStrategies,
  Gs as endpointPostStrategyGenerateData,
  qs as endpointPostStrategyIngestData,
  Ti as formatQueryGetScenariosNationalResults,
  Yt as getChunkSize,
  Is as getEndpointGetStoresSummaries,
  on as getEnvConfig,
  yt as getFileExt,
  Nt as handleDomException,
  Mt as handleHTTPStatus,
  pn as indexByProp,
  ma as preflightValidationDeleteProjects,
  ei as preflightValidationDeleteScenario,
  wt as preflightValidationGetAgentAssistants,
  $t as preflightValidationGetAgentMessage,
  zt as preflightValidationGetAgentRun,
  Wt as preflightValidationGetAgentThreads,
  lr as preflightValidationGetAssortment,
  rs as preflightValidationGetClusterPlanograms,
  Wa as preflightValidationGetConstraintTypess,
  Ea as preflightValidationGetCurateProduct,
  ua as preflightValidationGetCurateProductSummaries,
  ns as preflightValidationGetCurateStoreProducts,
  Es as preflightValidationGetCurateStores,
  br as preflightValidationGetDocuments,
  Fr as preflightValidationGetDocumentsSummaries,
  wr as preflightValidationGetEditRequestsMostRecent,
  mr as preflightValidationGetPODs,
  Ta as preflightValidationGetProductSummaries,
  la as preflightValidationGetProducts,
  Na as preflightValidationGetProjectDataDetails,
  Da as preflightValidationGetProjectExportUrl,
  Ya as preflightValidationGetProjects,
  ai as preflightValidationGetReviews,
  pi as preflightValidationGetScenarioGroups,
  li as preflightValidationGetScenarios,
  mi as preflightValidationGetScenariosBaseCore,
  Ii as preflightValidationGetScenariosNationalResults,
  hs as preflightValidationGetStoreKpiSummaries,
  Ps as preflightValidationGetStoreSummaries,
  As as preflightValidationGetStoresPlanograms,
  bs as preflightValidationGetStrategies,
  Os as preflightValidationGetStrategyAggregation,
  Nr as preflightValidationGetTasksStatus,
  tr as preflightValidationListAgentMessages,
  ja as preflightValidationPatchProject,
  $a as preflightValidationPatchProjectSettings,
  Li as preflightValidationPatchReview,
  gi as preflightValidationPatchScenario,
  bi as preflightValidationPatchScenarioAssignGroup,
  Fi as preflightValidationPatchScenarioGroupArchive,
  ji as preflightValidationPatchScenarioGroupArchiveUndo,
  $i as preflightValidationPatchScenarioGroupRename,
  Ws as preflightValidationPatchUserCustomerGroup,
  or as preflightValidationPostAgentAssistant,
  _r as preflightValidationPostAgentMessage,
  cr as preflightValidationPostAgentRun,
  Tr as preflightValidationPostAgentThread,
  xr as preflightValidationPostEditRequestsCreate,
  gr as preflightValidationPostExportAssortment,
  ys as preflightValidationPostExportPlanograms,
  Br as preflightValidationPostFilesUpload,
  ta as preflightValidationPostFilesUploadComplete,
  sa as preflightValidationPostFilesUploadPart,
  en as preflightValidationPostLoginPasswordless,
  za as preflightValidationPostProject,
  Zi as preflightValidationPostReview,
  Qi as preflightValidationPostScenarioGroups,
  xs as preflightValidationPostStrategies,
  Ms as preflightValidationPostStrategyGenerateData,
  ks as preflightValidationPostStrategyIngestData,
  nt as setUser,
  rt as setUserFeatures,
  at as setUserTenant,
  it as setUserTenantSlug,
  st as setUserToken,
  mt as sortByProp,
  Xn as useDeleteProject,
  po as useDeleteScenario,
  Le as useFetch,
  En as useFetchBatch,
  Gt as useFetchConcurrentAsyc,
  _n as useFetchDrain,
  O as useFetchRequest,
  tn as useFileChunkFormBuilder,
  jo as useFileUploadContextSSDI,
  vn as useGetAgentAssistants,
  hn as useGetAgentMessage,
  un as useGetAgentRun,
  cn as useGetAgentThreads,
  Nn as useGetAssortments,
  Ft as useGetChunk,
  Ro as useGetClusterPlanograms,
  oo as useGetConstraintTypes,
  kn as useGetCurateProduct,
  Kn as useGetCurateProductSummaries,
  Uo as useGetCurateStoreProducts,
  No as useGetCurateStores,
  Yo as useGetCustomerGroups,
  Cn as useGetDocuments,
  gn as useGetDocumentsSummaries,
  kr as useGetEditRequestsMostRecent,
  Fo as useGetMe,
  Ln as useGetPODs,
  wn as useGetPreferences,
  $n as useGetProductSummaries,
  xn as useGetProducts,
  zn as useGetProjectDataDetails,
  Bn as useGetProjectExportUrl,
  Jn as useGetProjects,
  Wn as useGetProjectsFileUploadConfig,
  Eo as useGetReviews,
  _o as useGetScenarioAggregationOptions,
  vo as useGetScenarioFileUploadConfig,
  ho as useGetScenarioGroups,
  co as useGetScenarios,
  Ao as useGetScenariosBaseCore,
  uo as useGetScenariosNationalResults,
  Lo as useGetStoreKpiSummaries,
  Oo as useGetStoresPlanograms,
  Co as useGetStoresSummaries,
  Ho as useGetStrategies,
  Do as useGetStrategyAggregation,
  Lr as useGetTasksStatus,
  qn as useGetTestAuth,
  An as useListAgentMessages,
  Qn as usePatchProject,
  eo as usePatchProjectSettings,
  Io as usePatchReview,
  To as usePatchScenario,
  So as usePatchScenarioAssignGroup,
  Po as usePatchScenarioGroupArchive,
  lo as usePatchScenarioGroupArchiveUndo,
  fo as usePatchScenarioGroupRename,
  Mo as usePatchUserCustomerGroup,
  ct as usePollTaskStatus,
  yn as usePostAgentAssistant,
  mn as usePostAgentMessage,
  Rn as usePostAgentRun,
  Un as usePostAgentThread,
  Dn as usePostEditRequestDropPosition,
  Hn as usePostEditRequestDropProduct,
  Vn as usePostEditRequestInsertPosition,
  bn as usePostEditRequestInsertProduct,
  Gn as usePostEditRequestMovePosition,
  Yn as usePostEditRequestSetFacings,
  Fn as usePostEditRequestSwapPosition,
  Mn as usePostEditRequestSwapProduct,
  Ae as usePostEditRequestsCreate,
  On as usePostExportAssortment,
  go as usePostExportPlanograms,
  Wr as usePostFilesUpload,
  ra as usePostFilesUploadComplete,
  na as usePostFilesUploadPart,
  qo as usePostLoginPasswordless,
  no as usePostProject,
  yo as usePostReview,
  mo as usePostScenarioGroups,
  Go as usePostStrategies,
  Vo as usePostStrategyGenerateData,
  bo as usePostStrategyIngestData,
  Dt as useSetUser,
  Lt as useSetUserFeatures,
  Ot as useSetUserTenant,
  Ct as useSetUserTenantSlug,
  gt as useSetUserToken,
  bt as useUserState,
  Ht as userReducer,
  J as validateBody,
  H as validateParams,
  ne as validateQuery,
  Ge as valueByProp
};
//# sourceMappingURL=api.js.map
